"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3004],{

/***/ 68479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 15 15"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8.34588 13.6273C8.0575 13.8656 7.63823 13.7399 7.49172 13.3958L6.78828 11.7438C7.73587 11.3939 8.62311 10.9234 9.44396 10.3744C9.44396 10.3744 9.66966 11.6436 9.38982 12.3723C9.20938 12.8421 8.73469 13.3061 8.34588 13.6273ZM3.25141 8.2087L1.60451 7.50815C1.25825 7.36086 1.1335 6.93831 1.37577 6.6505C1.69974 6.26564 2.16489 5.79794 2.63298 5.61886C3.35861 5.34125 4.62149 5.55437 4.62149 5.55437C4.07225 6.3748 3.60147 7.26158 3.25141 8.2087ZM12.8903 2.10977C12.8903 2.10977 9.90266 0.830267 6.4865 4.2453C5.1647 5.56643 4.37403 7.02028 3.861 8.29315C3.69201 8.7456 3.80668 9.24027 4.13864 9.57809L5.42423 10.857C5.75619 11.1948 6.25111 11.3034 6.70378 11.1345C8.22388 10.5552 9.6041 9.66087 10.7537 8.51033C14.1699 5.09589 12.8903 2.10977 12.8903 2.10977ZM8.62311 6.3748C8.15233 5.90426 8.15233 5.13812 8.62311 4.66758C9.09389 4.19704 9.86042 4.19704 10.3312 4.66758C10.7959 5.13812 10.802 5.90426 10.3312 6.3748C9.86042 6.84534 9.09389 6.84534 8.62311 6.3748Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3.77609 10.3019C3.54971 10.0756 3.23604 9.92849 2.92949 10.0208C2.22706 10.2322 1.71542 10.8838 1.71542 11.6548L1.71542 13.361H3.42253C4.19392 13.361 4.84581 12.8496 5.05736 12.1476C5.14968 11.8412 5.00246 11.5277 4.77608 11.3014L3.77609 10.3019Z"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 92176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* reexport */ Modal_ModalActions; },
  "S": function() { return /* reexport */ Modal_ModalInput; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/components/Modal/Spacer.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n  width: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Spacer = function(param) {
    var _size = param.size, size = _size === void 0 ? "md" : _size;
    var spacing = (0,react.useContext)(styled_components_browser_esm/* ThemeContext */.Ni).spacing;
    var s;
    switch(size){
        case "lg":
            s = spacing[6];
            break;
        case "sm":
            s = spacing[2];
            break;
        case "md":
        default:
            s = spacing[4];
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSpacer, {
        size: s
    });
};
var StyledSpacer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fdefb931-0"
})(_templateObject(), function(props) {
    return props.size;
}, function(props) {
    return props.size;
});
/* harmony default export */ var Modal_Spacer = (Spacer);

;// CONCATENATED MODULE: ./src/components/Modal/ModalActions.tsx

function ModalActions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        "00;\n  display: flex;\n  margin: 0;\n  padding: ",
        "px 0;\n"
    ]);
    ModalActions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var ModalActions = function(param) {
    var children = param.children;
    var l = react.Children.toArray(children).length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModalActions, {
        children: react.Children.map(children, function(child, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModalAction, {
                        children: child
                    }),
                    i < l - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Spacer, {})
                ]
            });
        })
    });
};
var StyledModalActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68b227bb-0"
})(ModalActions_templateObject(), function(props) {
    return props.theme.colors.primaryDark;
}, function(props) {
    return props.theme.spacing[4];
});
var StyledModalAction = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68b227bb-1"
})(_templateObject1());
/* harmony default export */ var Modal_ModalActions = (ModalActions);

// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(32762);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(98553);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var src = __webpack_require__(52775);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(61744);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
;// CONCATENATED MODULE: ./src/components/Modal/ModalInput.tsx

function ModalInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  border-radius: 16px;\n  box-shadow: ",
        ";\n  color: ",
        ";\n  padding: 8px 16px 8px 0;\n  width: 100%;\n"
    ]);
    ModalInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalInput_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: none;\n  width: 60px;\n  margin: 0 8px;\n  padding: 0 8px;\n  border: none;\n\n  ",
        " {\n    width: 80px;\n  }\n\n  ",
        " {\n    width: auto;\n  }\n"
    ]);
    ModalInput_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var StyledTokenInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4062fddb-0"
})(ModalInput_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme, isWarning = param.isWarning;
    return isWarning ? theme.colors.warning : theme.shadows.inset;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var StyledInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-4062fddb-1"
})(ModalInput_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var ModalInput = function(param) {
    var max = param.max, symbol = param.symbol, onChange = param.onChange, onSelectMax = param.onSelectMax, value = param.value, inputTitle = param.inputTitle, _decimals = param.decimals, decimals = _decimals === void 0 ? 18 : _decimals;
    var t = (0,src/* useTranslation */.$G)().t;
    var isBalanceZero = max === "0" || !max;
    var displayBalance = function(balance) {
        if (isBalanceZero) {
            return "0";
        }
        var balanceUnits = (0,lib_esm.parseUnits)(balance, decimals);
        return (0,formatBalance/* formatBigNumber */.dp)(balanceUnits, decimals, decimals);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            position: "relative"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTokenInput, {
            isWarning: isBalanceZero,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    pl: "16px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            children: inputTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            children: t("Balance: %balance%", {
                                balance: displayBalance(max)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    alignItems: "flex-end",
                    justifyContent: "space-around",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
                            pattern: "^[0-9]*[.,]?[0-9]{0,".concat(decimals, "}$"),
                            inputMode: "decimal",
                            step: "any",
                            min: "0",
                            onChange: onChange,
                            placeholder: "0",
                            value: value
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            scale: "sm",
                            onClick: onSelectMax,
                            mr: "8px",
                            children: t("Max")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "16px",
                            children: symbol
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Modal_ModalInput = (ModalInput);

;// CONCATENATED MODULE: ./src/components/Modal/index.ts




/***/ }),

/***/ 70372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AQ": function() { return /* binding */ stakeFarm; },
/* harmony export */   "dU": function() { return /* binding */ unstakeFarm; },
/* harmony export */   "sA": function() { return /* binding */ harvestFarm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44431);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(bignumber_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97478);






var options = {
    gasLimit: config__WEBPACK_IMPORTED_MODULE_2__/* .BOOSTED_FARM_GAS_LIMIT */ .ZM
};
var stakeFarm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(masterChefContract, pid, amount, gasPrice) {
        var value;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    value = new (bignumber_js__WEBPACK_IMPORTED_MODULE_1___default())(amount).times(config__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_TOKEN_DECIMAL */ .o3).toString();
                    return _ctx.abrupt("return", masterChefContract.deposit(pid, value, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                        gasPrice: gasPrice
                    })));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function stakeFarm(masterChefContract, pid, amount, gasPrice) {
        return _ref.apply(this, arguments);
    };
}();
var unstakeFarm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(masterChefContract, pid, amount, gasPrice) {
        var value;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    value = new (bignumber_js__WEBPACK_IMPORTED_MODULE_1___default())(amount).times(config__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_TOKEN_DECIMAL */ .o3).toString();
                    return _ctx.abrupt("return", masterChefContract.withdraw(pid, value, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                        gasPrice: gasPrice
                    })));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function unstakeFarm(masterChefContract, pid, amount, gasPrice) {
        return _ref.apply(this, arguments);
    };
}();
var harvestFarm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(masterChefContract, pid, gasPrice) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", masterChefContract.deposit(pid, "0", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                        gasPrice: gasPrice
                    })));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function harvestFarm(masterChefContract, pid, gasPrice) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 56946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zj": function() { return /* reexport */ callWithEstimateGas; },
  "yp": function() { return /* reexport */ getActivePools; },
  "sA": function() { return /* reexport */ farms/* harvestFarm */.sA; },
  "AQ": function() { return /* reexport */ farms/* stakeFarm */.AQ; },
  "dU": function() { return /* reexport */ farms/* unstakeFarm */.dU; }
});

// UNUSED EXPORTS: estimateGas

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
;// CONCATENATED MODULE: ./src/utils/calls/estimateGas.ts





/**
 * Estimate the gas needed to call a function, and add a 10% margin
 * @param contract Used to perform the call
 * @param methodName The name of the method called
 * @param gasMarginPer10000 The gasMargin per 10000 (i.e. 10% -> 1000)
 * @param args An array of arguments to pass to the method
 * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
 */ var estimateGas = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(contract, methodName, methodArgs) {
        var overrides, gasMarginPer10000, _estimateGas, rawGasEstimation, gasEstimation, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    overrides = _args.length > 3 && _args[3] !== void 0 ? _args[3] : {}, gasMarginPer10000 = _args.length > 4 ? _args[4] : void 0;
                    ;
                    if (contract[methodName]) {
                        _ctx.next = 4;
                        break;
                    }
                    throw new Error("Method ".concat(methodName, " doesn't exist on ").concat(contract.address));
                case 4:
                    _ctx.next = 6;
                    return (_estimateGas = contract.estimateGas)[methodName].apply(_estimateGas, (0,_to_consumable_array/* default */.Z)(methodArgs).concat([
                        overrides
                    ]));
                case 6:
                    rawGasEstimation = _ctx.sent;
                    gasEstimation = (0,utils/* calculateGasMargin */.yC)(rawGasEstimation, gasMarginPer10000);
                    return _ctx.abrupt("return", gasEstimation);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function estimateGas(contract, methodName, methodArgs) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Perform a contract call with a gas value returned from estimateGas
 * @param contract Used to perform the call
 * @param methodName The name of the method called
 * @param methodArgs An array of arguments to pass to the method
 * @param overrides An overrides object to pass to the method
 * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
 */ var callWithEstimateGas = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(contract, methodName, methodArgs) {
        var overrides, gasMarginPer10000, _contract, gasEstimation, tx, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    overrides = _args.length > 3 && _args[3] !== void 0 ? _args[3] : {}, gasMarginPer10000 = _args.length > 4 && _args[4] !== void 0 ? _args[4] : 1000;
                    ;
                    _ctx.next = 4;
                    return estimateGas(contract, methodName, methodArgs, overrides, gasMarginPer10000);
                case 4:
                    gasEstimation = _ctx.sent;
                    _ctx.next = 7;
                    return (_contract = contract)[methodName].apply(_contract, (0,_to_consumable_array/* default */.Z)(methodArgs).concat([
                        (0,_object_spread/* default */.Z)({
                            gasLimit: gasEstimation
                        }, overrides)
                    ]));
                case 7:
                    tx = _ctx.sent;
                    return _ctx.abrupt("return", tx);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function callWithEstimateGas(contract, methodName, methodArgs) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/utils/calls/farms.ts
var farms = __webpack_require__(70372);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var pools = __webpack_require__(62712);
// EXTERNAL MODULE: ./src/config/abi/sousChefV2.json
var sousChefV2 = __webpack_require__(9022);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(9796);
// EXTERNAL MODULE: ./src/utils/providers.ts
var providers = __webpack_require__(62621);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts + 1 modules
var addressHelpers = __webpack_require__(8414);
;// CONCATENATED MODULE: ./src/utils/calls/pools.ts
/* eslint-disable import/prefer-default-export */ 









/**
 * Returns the total number of pools that were active at a given block
 */ var getActivePools = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(block) {
        var eligiblePools, blockNumber, startBlockCalls, endBlockCalls, ref, startBlocks, endBlocks;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    eligiblePools = pools/* default.filter */.ZP.filter(function(pool) {
                        return pool.sousId !== 0;
                    }).filter(function(pool) {
                        return pool.isFinished === false || pool.isFinished === undefined;
                    });
                    _ctx.t0 = block;
                    if (_ctx.t0) {
                        _ctx.next = 6;
                        break;
                    }
                    _ctx.next = 5;
                    return providers/* bscRpcProvider.getBlockNumber */.v.getBlockNumber();
                case 5:
                    _ctx.t0 = _ctx.sent;
                case 6:
                    blockNumber = _ctx.t0;
                    startBlockCalls = eligiblePools.map(function(param) {
                        var contractAddress = param.contractAddress;
                        return {
                            address: (0,addressHelpers/* getAddress */.Kn)(contractAddress, 56),
                            name: "startBlock"
                        };
                    });
                    endBlockCalls = eligiblePools.map(function(param) {
                        var contractAddress = param.contractAddress;
                        return {
                            address: (0,addressHelpers/* getAddress */.Kn)(contractAddress, 56),
                            name: "bonusEndBlock"
                        };
                    });
                    _ctx.t1 = _sliced_to_array/* default */.Z;
                    _ctx.next = 12;
                    return Promise.all([
                        (0,multicall/* default */.Z)(sousChefV2, startBlockCalls),
                        (0,multicall/* default */.Z)(sousChefV2, endBlockCalls), 
                    ]);
                case 12:
                    _ctx.t2 = _ctx.sent;
                    ref = (0, _ctx.t1)(_ctx.t2, 2);
                    startBlocks = ref[0];
                    endBlocks = ref[1];
                    return _ctx.abrupt("return", eligiblePools.reduce(function(accum, poolCheck, index) {
                        var startBlock = startBlocks[index] ? new (bignumber_default())(startBlocks[index]) : null;
                        var endBlock = endBlocks[index] ? new (bignumber_default())(endBlocks[index]) : null;
                        if (!startBlock || !endBlock) {
                            return accum;
                        }
                        if (startBlock.gte(blockNumber) || endBlock.lte(blockNumber)) {
                            return accum;
                        }
                        return (0,_to_consumable_array/* default */.Z)(accum).concat([
                            poolCheck
                        ]);
                    }, []));
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getActivePools(block) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/utils/calls/index.ts





/***/ }),

/***/ 88100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40370);
// Constructing the two forward-slash-separated parts of the 'Add Liquidity' URL
// Each part of the url represents a different side of the LP pair.

var getLiquidityUrlPathParts = function(param) {
    var quoteTokenAddress = param.quoteTokenAddress, tokenAddress = param.tokenAddress;
    var wBnbAddress = _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTokens.wbnb.address */ .ds.wbnb.address;
    var firstPart = !quoteTokenAddress || quoteTokenAddress === wBnbAddress ? "BNB" : quoteTokenAddress;
    var secondPart = !tokenAddress || tokenAddress === wBnbAddress ? "BNB" : tokenAddress;
    return "".concat(firstPart, "/").concat(secondPart);
};
/* harmony default export */ __webpack_exports__["Z"] = (getLiquidityUrlPathParts);


/***/ }),

/***/ 35633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ FarmsContext; },
  "Z": function() { return /* binding */ Farms_Farms; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var src = __webpack_require__(29315);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(69589);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./packages/uikit/src/components/Image/Image.tsx
var Image = __webpack_require__(63970);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./packages/uikit/src/components/Toggle/Toggle.tsx + 2 modules
var Toggle = __webpack_require__(40628);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/Layout/Flex.tsx
var Layout_Flex = __webpack_require__(44142);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(27553);
// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 1 modules
var hooks = __webpack_require__(48674);
// EXTERNAL MODULE: ./src/state/pools/hooks.ts + 1 modules
var pools_hooks = __webpack_require__(83251);
// EXTERNAL MODULE: ./src/hooks/useIntersectionObserver.ts
var useIntersectionObserver = __webpack_require__(45636);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var localization_src = __webpack_require__(52775);
// EXTERNAL MODULE: ./src/utils/apr.ts + 1 modules
var apr = __webpack_require__(95347);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./src/utils/latinise.ts
var latinise = __webpack_require__(75660);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(921);
// EXTERNAL MODULE: ./src/state/user/actions.ts
var actions = __webpack_require__(9372);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/PageHeader/index.ts + 1 modules
var PageHeader = __webpack_require__(67274);
// EXTERNAL MODULE: ./src/components/SearchInput/index.ts + 1 modules
var SearchInput = __webpack_require__(19385);
// EXTERNAL MODULE: ./src/components/Select/Select.tsx
var Select = __webpack_require__(76688);
// EXTERNAL MODULE: ./src/components/Loading.tsx
var Loading = __webpack_require__(69117);
// EXTERNAL MODULE: ./src/components/ToggleView/ToggleView.tsx
var ToggleView = __webpack_require__(57329);
// EXTERNAL MODULE: ./src/components/ScrollToTopButton/ScrollToTopButtonV2.tsx
var ScrollToTopButtonV2 = __webpack_require__(77137);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(87318);
// EXTERNAL MODULE: ./src/views/Farms/components/getDisplayApr.ts
var getDisplayApr = __webpack_require__(17170);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(34701);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(62685);
// EXTERNAL MODULE: ./src/hooks/useDelayedUnmount.ts
var useDelayedUnmount = __webpack_require__(42219);
// EXTERNAL MODULE: ./src/components/Tags.tsx
var Tags = __webpack_require__(32675);
// EXTERNAL MODULE: ./src/views/Farms/components/FarmCard/ApyButton.tsx
var ApyButton = __webpack_require__(66140);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(97478);
// EXTERNAL MODULE: ./src/utils/getLiquidityUrlPathParts.ts
var getLiquidityUrlPathParts = __webpack_require__(88100);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Apr.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n\n  button {\n    width: 20px;\n    height: 20px;\n\n    svg {\n      path {\n        fill: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 60px;\n  text-align: left;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ff52fe8b-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var AprWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ff52fe8b-1"
})(_templateObject1());
var Apr = function(param) {
    var value = param.value, pid = param.pid, lpLabel = param.lpLabel, lpSymbol = param.lpSymbol, multiplier = param.multiplier, tokenAddress = param.tokenAddress, quoteTokenAddress = param.quoteTokenAddress, cakePrice = param.cakePrice, originalValue = param.originalValue, _hideButton = param.hideButton, hideButton = _hideButton === void 0 ? false : _hideButton, strikethrough = param.strikethrough, lpRewardsApr = param.lpRewardsApr, _useTooltipText = param.useTooltipText, useTooltipText = _useTooltipText === void 0 ? true : _useTooltipText;
    var liquidityUrlPathParts = (0,getLiquidityUrlPathParts/* default */.Z)({
        quoteTokenAddress: quoteTokenAddress,
        tokenAddress: tokenAddress
    });
    var addLiquidityUrl = "".concat(config/* BASE_ADD_LIQUIDITY_URL */.wI, "/").concat(liquidityUrlPathParts);
    return originalValue !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: originalValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ApyButton/* default */.Z, {
            variant: hideButton ? "text" : "text-and-button",
            pid: pid,
            lpSymbol: lpSymbol,
            lpLabel: lpLabel,
            multiplier: multiplier,
            cakePrice: cakePrice,
            apr: originalValue,
            displayApr: value,
            lpRewardsApr: lpRewardsApr,
            addLiquidityUrl: addLiquidityUrl,
            strikethrough: strikethrough,
            useTooltipText: useTooltipText,
            hideButton: hideButton
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AprWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                width: 60
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AprWrapper, {
            children: [
                originalValue,
                "%"
            ]
        })
    });
};
/* harmony default export */ var FarmTable_Apr = (Apr);

// EXTERNAL MODULE: ./src/components/TokenImage/index.tsx
var TokenImage = __webpack_require__(39023);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Farm.tsx

function Farm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 16px;\n  display: flex;\n  align-items: center;\n\n  ",
        " {\n    padding-left: 32px;\n  }\n"
    ]);
    Farm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Farm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 8px;\n  width: 32px;\n\n  ",
        " {\n    width: 40px;\n  }\n"
    ]);
    Farm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var Farm_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1316c1e9-0"
})(Farm_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var TokenWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1316c1e9-1"
})(Farm_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var Farm = function(param) {
    var token = param.token, quoteToken = param.quoteToken, label = param.label, pid = param.pid, isReady = param.isReady;
    var stakedBalance = (0,hooks/* useFarmUser */.Dx)(pid).stakedBalance;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var rawStakedBalance = (0,formatBalance/* getBalanceNumber */.mW)(stakedBalance);
    var handleRenderFarming = function() {
        if (rawStakedBalance) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "secondary",
                fontSize: "12px",
                bold: true,
                textTransform: "uppercase",
                children: t("Farming")
            });
        }
        return null;
    };
    if (!isReady) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Farm_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    mr: "8px",
                    width: 32,
                    height: 32,
                    variant: "circle"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            width: 40,
                            height: 10,
                            mb: "4px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            width: 60,
                            height: 24
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Farm_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenImage/* TokenPairImage */.q, {
                    variant: "inverted",
                    primaryToken: token,
                    secondaryToken: quoteToken,
                    width: 40,
                    height: 40
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    handleRenderFarming(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        children: label
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FarmTable_Farm = (Farm);

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Earned.tsx

function Earned_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n"
    ]);
    Earned_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Amount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-883b06dd-0"
})(Earned_templateObject(), function(param) {
    var earned = param.earned, theme = param.theme;
    return earned ? theme.colors.text : theme.colors.textDisabled;
});
var Earned = function(param) {
    var earnings = param.earnings, userDataReady = param.userDataReady;
    if (userDataReady) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Amount, {
            earned: earnings,
            children: earnings.toLocaleString()
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Amount, {
        earned: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            width: 60
        })
    });
};
/* harmony default export */ var FarmTable_Earned = (Earned);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(57049);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Details.tsx

function Details_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  justify-content: flex-end;\n  padding-right: 8px;\n  color: ",
        ";\n\n  ",
        " {\n    padding-right: 0px;\n  }\n"
    ]);
    Details_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Details_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: ",
        ";\n  height: 20px;\n"
    ]);
    Details_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var Details_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f9481682-0"
})(Details_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var ArrowIcon = (0,styled_components_browser_esm/* default */.ZP)(ChevronDown/* default */.Z).withConfig({
    componentId: "sc-f9481682-1"
})(Details_templateObject1(), function(param) {
    var toggled = param.toggled;
    return toggled ? "rotate(180deg)" : "rotate(0)";
});
var Details = function(param) {
    var actionPanelToggled = param.actionPanelToggled;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var isDesktop = (0,useMatchBreakpoints/* default */.Z)().isDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Details_Container, {
        children: [
            !isDesktop && t("Details"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {
                color: "primary",
                toggled: actionPanelToggled
            })
        ]
    });
};
/* harmony default export */ var FarmTable_Details = (Details);

// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(88896);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Help.tsx
var Help = __webpack_require__(95160);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Multiplier.tsx

function Multiplier_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n"
    ]);
    Multiplier_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Multiplier_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  width: 36px;\n  text-align: right;\n  margin-right: 14px;\n\n  ",
        " {\n    text-align: left;\n    margin-right: 0;\n  }\n"
    ]);
    Multiplier_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var ReferenceElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4294d98-0"
})(Multiplier_templateObject());
var MultiplierWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4294d98-1"
})(Multiplier_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var Multiplier_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4294d98-2"
})(_templateObject2());
var Multiplier = function(param) {
    var multiplier = param.multiplier;
    var displayMultiplier = multiplier ? multiplier.toLowerCase() : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        width: 30
    });
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var tooltipContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("The Multiplier represents the proportion of SHDW rewards each farm receives, as a proportion of the SHDW produced each block.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                my: "24px",
                children: t("For example, if a 1x farm received 1 SHDW per block, a 40x farm would receive 40 SHDW per block.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("This amount is already included in all APR calculations for the farm.")
            })
        ]
    });
    var ref = (0,useTooltip/* default */.Z)(tooltipContent, {
        placement: "top-end",
        tooltipOffset: [
            20,
            10
        ]
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Multiplier_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiplierWrapper, {
                children: displayMultiplier
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReferenceElement, {
                ref: targetRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                    color: "textSubtle"
                })
            }),
            tooltipVisible && tooltip
        ]
    });
};
/* harmony default export */ var FarmTable_Multiplier = (Multiplier);

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Liquidity.tsx

function Liquidity_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n"
    ]);
    Liquidity_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Liquidity_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 110px;\n  font-weight: 600;\n  text-align: right;\n  margin-right: 14px;\n\n  ",
        " {\n    text-align: left;\n    margin-right: 0;\n  }\n"
    ]);
    Liquidity_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Liquidity_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    Liquidity_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var Liquidity_ReferenceElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf44f1b9-0"
})(Liquidity_templateObject());
var LiquidityWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf44f1b9-1"
})(Liquidity_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var Liquidity_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf44f1b9-2"
})(Liquidity_templateObject2());
var Liquidity = function(param) {
    var liquidity = param.liquidity;
    var displayLiquidity = liquidity && liquidity.gt(0) ? "$".concat(Number(liquidity).toLocaleString(undefined, {
        maximumFractionDigits: 0
    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        width: 60
    });
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,useTooltip/* default */.Z)(t("Total value of the funds in this farm’s liquidity pool"), {
        placement: "top-end",
        tooltipOffset: [
            20,
            10
        ]
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Liquidity_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LiquidityWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: displayLiquidity
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Liquidity_ReferenceElement, {
                ref: targetRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                    color: "textSubtle"
                })
            }),
            tooltipVisible && tooltip
        ]
    });
};
/* harmony default export */ var FarmTable_Liquidity = (Liquidity);

// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(40735);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./src/views/Farms/components/FarmTable/Actions/HarvestAction.tsx + 1 modules
var HarvestAction = __webpack_require__(4679);
// EXTERNAL MODULE: ./src/views/Farms/components/FarmTable/Actions/StakedAction.tsx + 1 modules
var StakedAction = __webpack_require__(32624);
// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/components/BoostedAction.tsx + 5 modules
var BoostedAction = __webpack_require__(62006);
// EXTERNAL MODULE: ./src/views/Farms/components/FarmTable/Actions/styles.ts
var styles = __webpack_require__(5563);
// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/components/ProxyFarmContainer.tsx
var ProxyFarmContainer = __webpack_require__(28696);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Actions/ActionPanel.tsx



function ActionPanel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    max-height: 0px;\n  }\n  to {\n    max-height: 700px;\n  }\n"
    ]);
    ActionPanel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ActionPanel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    max-height: 700px;\n  }\n  to {\n    max-height: 0px;\n  }\n"
    ]);
    ActionPanel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ActionPanel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        " 300ms linear forwards\n        "
    ]);
    ActionPanel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        " 300ms linear forwards\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        ";\n  overflow: hidden;\n  background: ",
        ";\n  display: flex;\n  width: 100%;\n  flex-direction: column-reverse;\n  padding: 24px;\n\n  ",
        " {\n    flex-direction: row;\n    align-items: center;\n    padding: 16px 32px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n\n  ",
        " {\n    justify-content: flex-start;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  ",
        " {\n    flex-direction: row;\n    align-items: center;\n    flex-grow: 1;\n    flex-basis: 0;\n    flex-wrap: wrap;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 200px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 4px 0px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
















var expandAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(ActionPanel_templateObject());
var collapseAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(ActionPanel_templateObject1());
var ActionPanel_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-823401ac-0"
})(_templateObject4(), function(param) {
    var expanded = param.expanded;
    return expanded ? (0,styled_components_browser_esm/* css */.iv)(ActionPanel_templateObject2(), expandAnimation) : (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), collapseAnimation);
}, function(param) {
    var theme = param.theme;
    return theme.colors.dropdown;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var StyledLinkExternal = (0,styled_components_browser_esm/* default */.ZP)(LinkExternal/* default */.Z).withConfig({
    componentId: "sc-823401ac-1"
})(_templateObject5());
var StakeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-823401ac-2"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var ActionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-823401ac-3"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var InfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-823401ac-4"
})(_templateObject8());
var ValueContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-823401ac-5"
})(_templateObject9());
var ValueWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-823401ac-6"
})(_templateObject10());
var ActionPanel = function(param) {
    var details = param.details, apr = param.apr, multiplier = param.multiplier, liquidity = param.liquidity, userDataReady = param.userDataReady, expanded = param.expanded;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var ref = (0,react.useContext)(ProxyFarmContainer/* YieldBoosterStateContext */._), proxyFarm = ref.proxyFarm, shouldUseProxyFarm = ref.shouldUseProxyFarm;
    var farm = details;
    var isDesktop = (0,useMatchBreakpoints/* default */.Z)().isDesktop;
    var ref1 = (0,localization_src/* useTranslation */.$G)(), t = ref1.t, locale = ref1.currentLanguage.locale;
    var isActive = farm.multiplier !== "0X";
    var quoteToken = farm.quoteToken, token = farm.token;
    var lpLabel = farm.lpSymbol && farm.lpSymbol.toUpperCase().replace("SHADOW", "");
    var liquidityUrlPathParts = (0,getLiquidityUrlPathParts/* default */.Z)({
        quoteTokenAddress: quoteToken.address,
        tokenAddress: token.address
    });
    var lpAddress = farm.lpAddress;
    var bsc = (0,utils/* getBlockExploreLink */.C)(lpAddress, "address", chainId);
    var info = "/info/pool/".concat(lpAddress);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionPanel_Container, {
        expanded: expanded,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ValueContainer, {
                        children: [
                            farm.isCommunity && farm.auctionHostingEndDate && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ValueWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: t("Auction Hosting Ends")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        paddingLeft: "4px",
                                        children: new Date(farm.auctionHostingEndDate).toLocaleString(locale, {
                                            month: "short",
                                            day: "numeric",
                                            year: "numeric"
                                        })
                                    })
                                ]
                            }),
                            !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ValueWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: t("APR")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Apr, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, apr), {
                                                useTooltipText: false
                                            }))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ValueWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: t("Multiplier")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Multiplier, (0,_object_spread/* default */.Z)({}, multiplier))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ValueWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: t("Liquidity")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Liquidity, (0,_object_spread/* default */.Z)({}, liquidity))
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(StakeContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkExternal, {
                            href: "/add/".concat(liquidityUrlPathParts),
                            children: t("Get %symbol%", {
                                symbol: lpLabel
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkExternal, {
                        href: bsc,
                        children: t("View Contract")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkExternal, {
                        href: info,
                        children: t("See Pair Info")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
                children: [
                    shouldUseProxyFarm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HarvestAction/* ProxyHarvestActionContainer */.nG, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, proxyFarm), {
                        userDataReady: userDataReady,
                        children: function(props) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HarvestAction/* HarvestAction */.xO, (0,_object_spread/* default */.Z)({}, props));
                        }
                    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HarvestAction/* HarvestActionContainer */.ln, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, farm), {
                        userDataReady: userDataReady,
                        children: function(props) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HarvestAction/* HarvestAction */.xO, (0,_object_spread/* default */.Z)({}, props));
                        }
                    })),
                    (farm === null || farm === void 0 ? void 0 : farm.boosted) && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ActionContainer */.sX, {
                        style: {
                            minHeight: 124.5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoostedAction/* default */.Z, {
                            title: function(status) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ActionTitles */.Ad, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "3px",
                                            bold: true,
                                            textTransform: "uppercase",
                                            color: "textSubtle",
                                            fontSize: "12px",
                                            children: t("Yield Booster")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            bold: true,
                                            textTransform: "uppercase",
                                            color: "secondary",
                                            fontSize: "12px",
                                            children: status
                                        })
                                    ]
                                });
                            },
                            desc: function(actionBtn) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ActionContent */.O6, {
                                    children: actionBtn
                                });
                            },
                            farmPid: farm === null || farm === void 0 ? void 0 : farm.pid
                        })
                    }),
                    shouldUseProxyFarm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StakedAction/* ProxyStakedContainer */.sf, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, proxyFarm), {
                        userDataReady: userDataReady,
                        lpLabel: lpLabel,
                        displayApr: apr.value,
                        children: function(props) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StakedAction/* default */.ZP, (0,_object_spread/* default */.Z)({}, props));
                        }
                    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StakedAction/* StakedContainer */.pK, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, farm), {
                        userDataReady: userDataReady,
                        lpLabel: lpLabel,
                        displayApr: apr.value,
                        children: function(props) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StakedAction/* default */.ZP, (0,_object_spread/* default */.Z)({}, props));
                        }
                    }))
                ]
            })
        ]
    });
};
/* harmony default export */ var Actions_ActionPanel = (ActionPanel);

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/CellLayout.tsx

function CellLayout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  color: ",
        ";\n  text-align: left;\n"
    ]);
    CellLayout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CellLayout_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 24px;\n  display: flex;\n  align-items: center;\n"
    ]);
    CellLayout_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-554acf73-0"
})(CellLayout_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var ContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-554acf73-1"
})(CellLayout_templateObject1());
var CellLayout = function(param) {
    var _label = param.label, label = _label === void 0 ? "" : _label, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer, {
                children: children
            })
        ]
    });
};
/* harmony default export */ var FarmTable_CellLayout = (CellLayout);

;// CONCATENATED MODULE: ./src/views/Farms/components/types.ts
var MobileColumnSchema = [
    {
        id: 1,
        name: "farm",
        sortable: true,
        label: ""
    },
    {
        id: 2,
        name: "earned",
        sortable: true,
        label: "Earned"
    },
    {
        id: 3,
        name: "apr",
        sortable: true,
        label: "APR"
    },
    {
        id: 6,
        name: "details",
        sortable: true,
        label: ""
    }, 
];
var DesktopColumnSchema = [
    {
        id: 1,
        name: "farm",
        sortable: true,
        label: ""
    },
    {
        id: 2,
        name: "type",
        sortable: false,
        label: ""
    },
    {
        id: 3,
        name: "earned",
        sortable: true,
        label: "Earned"
    },
    {
        id: 4,
        name: "apr",
        sortable: true,
        label: "APR"
    },
    {
        id: 5,
        name: "liquidity",
        sortable: true,
        label: "Liquidity"
    },
    {
        id: 6,
        name: "multiplier",
        sortable: true,
        label: "Multiplier"
    },
    {
        id: 7,
        name: "details",
        sortable: true,
        label: ""
    }, 
];

// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/components/BoostedApr.tsx
var BoostedApr = __webpack_require__(52914);
// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/components/BoostedTag.tsx
var BoostedTag = __webpack_require__(39085);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Row.tsx



function Row_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px 0px;\n  display: flex;\n  width: 100%;\n  align-items: center;\n  padding-right: 8px;\n\n  ",
        " {\n    padding-right: 32px;\n  }\n"
    ]);
    Row_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Row_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  &:not(:last-child) {\n    border-bottom: 2px solid ",
        ";\n  }\n"
    ]);
    Row_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Row_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 0 24px 16px;\n"
    ]);
    Row_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Row_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 16px;\n  padding-bottom: 24px;\n"
    ]);
    Row_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Row_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 24px;\n"
    ]);
    Row_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



















var cells = {
    apr: FarmTable_Apr,
    farm: FarmTable_Farm,
    earned: FarmTable_Earned,
    details: FarmTable_Details,
    multiplier: FarmTable_Multiplier,
    liquidity: FarmTable_Liquidity
};
var CellInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2fad5cf1-0"
})(Row_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xl;
});
var StyledTr = styled_components_browser_esm/* default.tr.withConfig */.ZP.tr.withConfig({
    componentId: "sc-2fad5cf1-1"
})(Row_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.disabled;
});
var EarnedMobileCell = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-2fad5cf1-2"
})(Row_templateObject2());
var AprMobileCell = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-2fad5cf1-3"
})(Row_templateObject3());
var FarmMobileCell = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-2fad5cf1-4"
})(Row_templateObject4());
var Row = function(props) {
    var details = props.details, initialActivity = props.initialActivity, multiplier = props.multiplier;
    var userDataReady = multiplier.multiplier !== undefined;
    var hasSetInitialValue = (0,react.useRef)(false);
    var hasStakedAmount = !!(0,hooks/* useFarmUser */.Dx)(details.pid).stakedBalance.toNumber();
    var ref = (0,react.useState)(hasStakedAmount), actionPanelExpanded = ref[0], setActionPanelExpanded = ref[1];
    var shouldRenderChild = (0,useDelayedUnmount/* default */.Z)(actionPanelExpanded, 300);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var toggleActionPanel = function() {
        setActionPanelExpanded(!actionPanelExpanded);
    };
    (0,react.useEffect)(function() {
        setActionPanelExpanded(hasStakedAmount);
    }, [
        hasStakedAmount
    ]);
    (0,react.useEffect)(function() {
        if (initialActivity && hasSetInitialValue.current === false) {
            setActionPanelExpanded(initialActivity);
            hasSetInitialValue.current = true;
        }
    }, [
        initialActivity
    ]);
    var ref1 = (0,useMatchBreakpoints/* default */.Z)(), isDesktop = ref1.isDesktop, isMobile = ref1.isMobile;
    var isSmallerScreen = !isDesktop;
    var tableSchema = isSmallerScreen ? MobileColumnSchema : DesktopColumnSchema;
    var columnNames = tableSchema.map(function(column) {
        return column.name;
    });
    var handleRenderRow = function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (!isMobile) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTr, {
                onClick: toggleActionPanel,
                children: Object.keys(props).map(function(key) {
                    var columnIndex = columnNames.indexOf(key);
                    if (columnIndex === -1) {
                        return null;
                    }
                    switch(key){
                        case "type":
                            var ref;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: userDataReady ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CellInner, {
                                    style: {
                                        width: "140px"
                                    },
                                    children: [
                                        props[key] === "community" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags/* FarmAuctionTag */.Vi, {
                                            scale: "sm"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags/* CoreTag */.eE, {
                                            scale: "sm"
                                        }),
                                        (props === null || props === void 0 ? void 0 : (ref = props.details) === null || ref === void 0 ? void 0 : ref.boosted) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BoostedTag/* default */.Z, {
                                            scale: "sm",
                                            ml: "16px"
                                        }) : null
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    width: 60,
                                    height: 24
                                })
                            }, key);
                        case "details":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CellInner, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_CellLayout, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Details, {
                                            actionPanelToggled: actionPanelExpanded
                                        })
                                    })
                                })
                            }, key);
                        case "apr":
                            var ref1, ref2, ref3, ref4, ref5;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CellInner, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FarmTable_CellLayout, {
                                        label: t("APR"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Apr, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.apr), {
                                                hideButton: isSmallerScreen,
                                                strikethrough: props === null || props === void 0 ? void 0 : (ref1 = props.details) === null || ref1 === void 0 ? void 0 : ref1.boosted
                                            })),
                                            (props === null || props === void 0 ? void 0 : (ref2 = props.details) === null || ref2 === void 0 ? void 0 : ref2.boosted) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BoostedApr/* default */.Z, {
                                                lpRewardsApr: props === null || props === void 0 ? void 0 : (ref3 = props.apr) === null || ref3 === void 0 ? void 0 : ref3.lpRewardsApr,
                                                apr: props === null || props === void 0 ? void 0 : (ref4 = props.apr) === null || ref4 === void 0 ? void 0 : ref4.originalValue,
                                                pid: (ref5 = props.farm) === null || ref5 === void 0 ? void 0 : ref5.pid
                                            }) : null
                                        ]
                                    })
                                })
                            }, key);
                        default:
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CellInner, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_CellLayout, {
                                        label: t(tableSchema[columnIndex].label),
                                        children: /*#__PURE__*/ (0,react.createElement)(cells[key], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props[key]), {
                                            userDataReady: userDataReady
                                        }))
                                    })
                                })
                            }, key);
                    }
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    style: {
                        cursor: "pointer"
                    },
                    onClick: toggleActionPanel,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmMobileCell, {
                        colSpan: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Farm, (0,_object_spread/* default */.Z)({}, props.farm)),
                                props.type === "community" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags/* FarmAuctionTag */.Vi, {
                                    marginRight: "16px",
                                    scale: "sm"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    style: {
                                        marginRight: "16px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags/* CoreTag */.eE, {
                                            scale: "sm"
                                        }),
                                        (props === null || props === void 0 ? void 0 : (ref = props.details) === null || ref === void 0 ? void 0 : ref.boosted) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BoostedTag/* default */.Z, {
                                            style: {
                                                verticalAlign: "bottom"
                                            },
                                            scale: "sm",
                                            ml: "4px"
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTr, {
                    onClick: toggleActionPanel,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            width: "33%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EarnedMobileCell, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_CellLayout, {
                                    label: t("Earned"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Earned, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.earned), {
                                        userDataReady: userDataReady
                                    }))
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            width: "33%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AprMobileCell, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FarmTable_CellLayout, {
                                    label: t("APR"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Apr, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.apr), {
                                            hideButton: true,
                                            strikethrough: props === null || props === void 0 ? void 0 : (ref1 = props.details) === null || ref1 === void 0 ? void 0 : ref1.boosted
                                        })),
                                        (props === null || props === void 0 ? void 0 : (ref2 = props.details) === null || ref2 === void 0 ? void 0 : ref2.boosted) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BoostedApr/* default */.Z, {
                                            lpRewardsApr: props === null || props === void 0 ? void 0 : (ref3 = props.apr) === null || ref3 === void 0 ? void 0 : ref3.lpRewardsApr,
                                            apr: props === null || props === void 0 ? void 0 : (ref4 = props.apr) === null || ref4 === void 0 ? void 0 : ref4.originalValue,
                                            pid: (ref5 = props.farm) === null || ref5 === void 0 ? void 0 : ref5.pid
                                        }) : null
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            width: "33%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CellInner, {
                                style: {
                                    justifyContent: "flex-end"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Details, {
                                    actionPanelToggled: actionPanelExpanded
                                })
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            handleRenderRow(),
            shouldRenderChild && /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    colSpan: 7,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Actions_ActionPanel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        expanded: actionPanelExpanded
                    }))
                })
            })
        ]
    });
};
/* harmony default export */ var FarmTable_Row = (Row);

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/FarmTable.tsx



function FarmTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background: ",
        ";\n  border-radius: 16px;\n  margin: 16px 0px;\n  border: 1px solid ",
        ";\n"
    ]);
    FarmTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FarmTable_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: visible;\n  scroll-margin-top: 64px;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    FarmTable_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FarmTable_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-collapse: collapse;\n  font-size: 14px;\n  border-radius: 4px;\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n"
    ]);
    FarmTable_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FarmTable_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & tr {\n    td {\n      font-size: 16px;\n      vertical-align: middle;\n    }\n  }\n"
    ]);
    FarmTable_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FarmTable_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    FarmTable_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}













var FarmTable_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5adbd70-0"
})(FarmTable_templateObject(), function(param) {
    var theme = param.theme;
    return theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var TableWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5adbd70-1"
})(FarmTable_templateObject1());
var StyledTable = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-5adbd70-2"
})(FarmTable_templateObject2());
var TableBody = styled_components_browser_esm/* default.tbody.withConfig */.ZP.tbody.withConfig({
    componentId: "sc-5adbd70-3"
})(FarmTable_templateObject3());
var TableContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5adbd70-4"
})(FarmTable_templateObject4());
var FarmTable = function(param) {
    var farms = param.farms, cakePrice = param.cakePrice, userDataReady = param.userDataReady;
    var tableWrapperEl = (0,react.useRef)(null);
    var query = (0,next_router.useRouter)().query;
    var columns = (0,react.useMemo)(function() {
        return DesktopColumnSchema.map(function(column) {
            return {
                id: column.id,
                name: column.name,
                label: column.label,
                sort: function(a, b) {
                    switch(column.name){
                        case "farm":
                            return b.id - a.id;
                        case "apr":
                            if (a.original.apr.value && b.original.apr.value) {
                                return Number(a.original.apr.value) - Number(b.original.apr.value);
                            }
                            return 0;
                        case "earned":
                            return a.original.earned.earnings - b.original.earned.earnings;
                        default:
                            return 1;
                    }
                },
                sortable: column.sortable
            };
        });
    }, []);
    var getFarmEarnings = function(farm) {
        var earnings = bigNumber/* BIG_ZERO */.HW;
        var existingEarnings = new (bignumber_default())(farm.userData.earnings);
        if (farm.boosted) {
            var ref, ref1;
            var proxyEarnings = new (bignumber_default())((ref = farm.userData) === null || ref === void 0 ? void 0 : (ref1 = ref.proxy) === null || ref1 === void 0 ? void 0 : ref1.earnings);
            earnings = proxyEarnings.gt(0) ? proxyEarnings : existingEarnings;
        } else {
            earnings = existingEarnings;
        }
        return (0,formatBalance/* getBalanceNumber */.mW)(earnings);
    };
    var generateRow = function(farm) {
        var token = farm.token, quoteToken = farm.quoteToken;
        var tokenAddress = token.address;
        var quoteTokenAddress = quoteToken.address;
        var lpLabel = farm.lpSymbol && farm.lpSymbol.split(" ")[0].toUpperCase().replace("SHADOW", "");
        var lowercaseQuery = (0,latinise/* latinise */.b)(typeof (query === null || query === void 0 ? void 0 : query.search) === "string" ? query.search.toLowerCase() : "");
        var initialActivity = (0,latinise/* latinise */.b)(lpLabel === null || lpLabel === void 0 ? void 0 : lpLabel.toLowerCase()) === lowercaseQuery;
        var row = {
            apr: {
                value: (0,getDisplayApr/* getDisplayApr */.V)(farm.apr, farm.lpRewardsApr),
                pid: farm.pid,
                multiplier: farm.multiplier,
                lpLabel: lpLabel,
                lpSymbol: farm.lpSymbol,
                tokenAddress: tokenAddress,
                quoteTokenAddress: quoteTokenAddress,
                cakePrice: cakePrice,
                lpRewardsApr: farm.lpRewardsApr,
                originalValue: farm.apr
            },
            farm: {
                label: lpLabel,
                pid: farm.pid,
                token: farm.token,
                quoteToken: farm.quoteToken,
                isReady: farm.multiplier !== undefined
            },
            earned: {
                earnings: getFarmEarnings(farm),
                pid: farm.pid
            },
            liquidity: {
                liquidity: farm === null || farm === void 0 ? void 0 : farm.liquidity
            },
            multiplier: {
                multiplier: farm.multiplier
            },
            type: farm.isCommunity ? "community" : "core",
            details: farm,
            initialActivity: initialActivity
        };
        return row;
    };
    var rowData = farms.map(function(farm) {
        return generateRow(farm);
    });
    var generateSortedRow = function(row) {
        // @ts-ignore
        var newRow = {};
        columns.forEach(function(column) {
            if (!(column.name in row)) {
                throw new Error("Invalid row data, ".concat(column.name, " not found"));
            }
            newRow[column.name] = row[column.name];
        });
        newRow.initialActivity = row.initialActivity;
        return newRow;
    };
    var sortedRows = rowData.map(generateSortedRow);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Container, {
        id: "farms-table",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer, {
            id: "table-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableWrapper, {
                ref: tableWrapperEl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTable, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody, {
                        children: sortedRows.map(function(row) {
                            var ref;
                            return (row === null || row === void 0 ? void 0 : (ref = row.details) === null || ref === void 0 ? void 0 : ref.boosted) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProxyFarmContainer/* default */.Z, {
                                farm: row.details,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Row, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, row), {
                                    userDataReady: userDataReady
                                }))
                            }, "table-row-".concat(row.farm.pid)) : /*#__PURE__*/ (0,react.createElement)(FarmTable_Row, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, row), {
                                userDataReady: userDataReady,
                                key: "table-row-".concat(row.farm.pid)
                            }));
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var FarmTable_FarmTable = (FarmTable);

// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenu.tsx
var ButtonMenu = __webpack_require__(12587);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenuItem.tsx
var ButtonMenuItem = __webpack_require__(51983);
// EXTERNAL MODULE: ./packages/uikit/src/components/NotificationDot/NotificationDot.tsx
var NotificationDot = __webpack_require__(85765);
// EXTERNAL MODULE: ./src/components/NextLink.tsx
var NextLink = __webpack_require__(12966);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTabButtons/index.tsx

function FarmTabButtons_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  a {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  ",
        " {\n    margin-left: 16px;\n  }\n"
    ]);
    FarmTabButtons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var FarmTabButtons = function(param) {
    var hasStakeInFinishedFarms = param.hasStakeInFinishedFarms;
    var router = (0,next_router.useRouter)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var activeIndex;
    switch(router.pathname){
        case "/farms":
            activeIndex = 0;
            break;
        case "/farms/history":
            activeIndex = 1;
            break;
        case "/_mp/farms/history":
            activeIndex = 1;
            break;
        case "/farms/archived":
            activeIndex = 2;
            break;
        default:
            activeIndex = 0;
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonMenu/* default */.Z, {
            activeIndex: activeIndex,
            scale: "sm",
            variant: "subtle",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                    as: NextLink/* NextLinkFromReactRouter */.a,
                    to: "/farms",
                    children: t("Live")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationDot/* default */.Z, {
                    show: hasStakeInFinishedFarms,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                        as: NextLink/* NextLinkFromReactRouter */.a,
                        to: "/farms/history",
                        id: "finished-farms-button",
                        children: t("Finished")
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_FarmTabButtons = (FarmTabButtons);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e043354b-0"
})(FarmTabButtons_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});

;// CONCATENATED MODULE: ./src/views/Farms/Farms.tsx




function Farms_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  position: relative;\n\n  justify-content: space-between;\n  flex-direction: column;\n  margin-bottom: 32px;\n\n  ",
        " {\n    flex-direction: row;\n    flex-wrap: wrap;\n    padding: 16px 32px;\n    margin-bottom: 0;\n  }\n"
    ]);
    Farms_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Farms_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-wrap: wrap;\n  ",
        " {\n    flex-wrap: nowrap;\n  }\n"
    ]);
    Farms_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Farms_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 32px;\n  margin-bottom: 8px;\n  ",
        " {\n    font-size: 64px;\n    margin-bottom: 24px;\n  }\n"
    ]);
    Farms_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Farms_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  margin-bottom: 8px;\n  ",
        " {\n    font-size: 24px;\n    margin-bottom: 18px;\n  }\n"
    ]);
    Farms_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Farms_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-left: 10px;\n\n  ",
        " {\n    margin-left: 8px;\n  }\n"
    ]);
    Farms_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Farms_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > ",
        " {\n    font-size: 12px;\n  }\n"
    ]);
    Farms_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Farms_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 8px 0px;\n\n  ",
        " {\n    width: auto;\n    padding: 0;\n  }\n"
    ]);
    Farms_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Farms_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-wrap: wrap;\n  justify-content: space-between;\n  display: flex;\n  align-items: center;\n  width: 100%;\n\n  > div {\n    padding: 8px 0px;\n  }\n\n  ",
        " {\n    justify-content: flex-start;\n    width: auto;\n\n    > div {\n      padding: 0;\n    }\n  }\n"
    ]);
    Farms_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Farms_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 58px;\n"
    ]);
    Farms_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




























var ControlContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3ddfe3c3-0"
})(Farms_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var FarmFlexWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3ddfe3c3-1"
})(Farms_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var FarmH1 = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-3ddfe3c3-2"
})(Farms_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var FarmH2 = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-3ddfe3c3-3"
})(Farms_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var ToggleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3ddfe3c3-4"
})(Farms_templateObject4(), Text/* default */.Z);
var LabelWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3ddfe3c3-5"
})(Farms_templateObject5(), Text/* default */.Z);
var FilterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3ddfe3c3-6"
})(Farms_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var ViewControls = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3ddfe3c3-7"
})(Farms_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var StyledImage = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-3ddfe3c3-8"
})(Farms_templateObject8());
var NUMBER_OF_FARMS_VISIBLE = 12;
var Farms = function(param) {
    var children = param.children;
    var ref = (0,next_router.useRouter)(), pathname = ref.pathname, urlQuery = ref.query;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var ref1 = (0,hooks/* useFarms */.E2)(), farmsLP = ref1.data, userDataLoaded = ref1.userDataLoaded, poolLength = ref1.poolLength, regularShdwPerBlock = ref1.regularShdwPerBlock;
    var cakePrice = (0,hooks/* usePriceCakeBusd */.Iu)();
    var ref2 = (0,react.useState)(""), _query = ref2[0], setQuery = ref2[1];
    var normalizedUrlSearch = (0,react.useMemo)(function() {
        return typeof (urlQuery === null || urlQuery === void 0 ? void 0 : urlQuery.search) === "string" ? urlQuery.search : "";
    }, [
        urlQuery
    ]);
    var query = normalizedUrlSearch && !_query ? normalizedUrlSearch : _query;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserFarmsViewMode */.y9)(), 2), viewMode = ref3[0], setViewMode = ref3[1];
    var account = (0,src/* useWeb3React */.Ge)().account;
    var ref4 = (0,react.useState)("hot"), sortOption = ref4[0], setSortOption = ref4[1];
    var ref5 = (0,useIntersectionObserver/* default */.Z)(), observerRef = ref5.observerRef, isIntersecting = ref5.isIntersecting;
    var chosenFarmsLength = (0,react.useRef)(0);
    var isArchived = pathname.includes("archived");
    var isInactive = pathname.includes("history");
    var isActive = !isInactive && !isArchived;
    (0,pools_hooks/* useCakeVaultUserData */.Es)();
    (0,hooks/* usePollFarmsWithUserData */.Cs)();
    // Users with no wallet connected should see 0 as Earned amount
    // Connected users should see loading indicator until first userData has loaded
    var userDataReady = !account || !!account && userDataLoaded;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserFarmStakedOnly */.XD)(isActive), 2), stakedOnly = ref6[0], setStakedOnly = ref6[1];
    var ref7 = (0,react.useState)(false), boostedOnly = ref7[0], setBoostedOnly = ref7[1];
    var activeFarms = farmsLP.filter(function(farm) {
        return farm.pid !== 0 && farm.multiplier !== "0X" && (!poolLength || poolLength > farm.pid);
    });
    var inactiveFarms = farmsLP.filter(function(farm) {
        return farm.pid !== 0 && farm.multiplier === "0X";
    });
    var archivedFarms = farmsLP;
    var stakedOnlyFarms = activeFarms.filter(function(farm) {
        var ref;
        return farm.userData && (new (bignumber_default())(farm.userData.stakedBalance).isGreaterThan(0) || new (bignumber_default())((ref = farm.userData.proxy) === null || ref === void 0 ? void 0 : ref.stakedBalance).isGreaterThan(0));
    });
    var stakedInactiveFarms = inactiveFarms.filter(function(farm) {
        var ref;
        return farm.userData && (new (bignumber_default())(farm.userData.stakedBalance).isGreaterThan(0) || new (bignumber_default())((ref = farm.userData.proxy) === null || ref === void 0 ? void 0 : ref.stakedBalance).isGreaterThan(0));
    });
    var stakedArchivedFarms = archivedFarms.filter(function(farm) {
        var ref;
        return farm.userData && (new (bignumber_default())(farm.userData.stakedBalance).isGreaterThan(0) || new (bignumber_default())((ref = farm.userData.proxy) === null || ref === void 0 ? void 0 : ref.stakedBalance).isGreaterThan(0));
    });
    var farmsList = (0,react.useCallback)(function(farmsToDisplay) {
        var farmsToDisplayWithAPR = farmsToDisplay.map(function(farm) {
            // if (!farm.lpTotalInQuoteToken || !farm.quoteTokenPriceBusd) {
            //   return farm
            // }
            // -ALEX HERE Uncomment
            var totalLiquidity = new (bignumber_default())(farm.lpTotalInQuoteToken).times(new (bignumber_default())(1));
            console.log("HERE ++");
            var ref = isActive ? (0,apr/* getFarmApr */.yW)(chainId, new (bignumber_default())(farm.poolWeight), cakePrice, totalLiquidity, farm.lpAddress, regularShdwPerBlock) : {
                cakeRewardsApr: 0,
                lpRewardsApr: 0
            }, cakeRewardsApr = ref.cakeRewardsApr, lpRewardsApr = ref.lpRewardsApr;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, farm), {
                apr: cakeRewardsApr,
                lpRewardsApr: lpRewardsApr,
                liquidity: totalLiquidity
            });
        });
        if (query) {
            var lowercaseQuery = (0,latinise/* latinise */.b)(query.toLowerCase());
            farmsToDisplayWithAPR = farmsToDisplayWithAPR.filter(function(farm) {
                return (0,latinise/* latinise */.b)(farm.lpSymbol.toLowerCase()).includes(lowercaseQuery);
            });
        }
        return farmsToDisplayWithAPR;
    }, [
        query,
        isActive,
        chainId,
        cakePrice,
        regularShdwPerBlock
    ]);
    var handleChangeQuery = function(event) {
        setQuery(event.target.value);
    };
    var ref8 = (0,react.useState)(NUMBER_OF_FARMS_VISIBLE), numberOfFarmsVisible = ref8[0], setNumberOfFarmsVisible = ref8[1];
    var chosenFarmsMemoized = (0,react.useMemo)(function() {
        var chosenFarms = [];
        var sortFarms = function(farms) {
            switch(sortOption){
                case "apr":
                    return orderBy_default()(farms, function(farm) {
                        return farm.apr + farm.lpRewardsApr;
                    }, "desc");
                case "multiplier":
                    return orderBy_default()(farms, function(farm) {
                        return farm.multiplier ? Number(farm.multiplier.slice(0, -1)) : 0;
                    }, "desc");
                case "earned":
                    return orderBy_default()(farms, function(farm) {
                        return farm.userData ? Number(farm.userData.earnings) : 0;
                    }, "desc");
                case "liquidity":
                    return orderBy_default()(farms, function(farm) {
                        return Number(farm.liquidity);
                    }, "desc");
                case "latest":
                    return orderBy_default()(farms, function(farm) {
                        return Number(farm.pid);
                    }, "desc");
                default:
                    return farms;
            }
        };
        if (isActive) {
            chosenFarms = stakedOnly ? farmsList(stakedOnlyFarms) : farmsList(activeFarms);
        }
        if (isInactive) {
            chosenFarms = stakedOnly ? farmsList(stakedInactiveFarms) : farmsList(inactiveFarms);
        }
        if (isArchived) {
            chosenFarms = stakedOnly ? farmsList(stakedArchivedFarms) : farmsList(archivedFarms);
        }
        if (boostedOnly) {
            chosenFarms = chosenFarms.filter(function(f) {
                return f.boosted;
            });
        }
        return sortFarms(chosenFarms).slice(0, numberOfFarmsVisible);
    }, [
        sortOption,
        activeFarms,
        farmsList,
        inactiveFarms,
        archivedFarms,
        isActive,
        isInactive,
        isArchived,
        stakedArchivedFarms,
        stakedInactiveFarms,
        stakedOnly,
        stakedOnlyFarms,
        numberOfFarmsVisible,
        boostedOnly, 
    ]);
    chosenFarmsLength.current = chosenFarmsMemoized.length;
    (0,react.useEffect)(function() {
        if (isIntersecting) {
            setNumberOfFarmsVisible(function(farmsCurrentlyVisible) {
                if (farmsCurrentlyVisible <= chosenFarmsLength.current) {
                    return farmsCurrentlyVisible + NUMBER_OF_FARMS_VISIBLE;
                }
                return farmsCurrentlyVisible;
            });
        }
    }, [
        isIntersecting
    ]);
    var handleSortOptionChange = function(option) {
        setSortOption(option.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FarmsContext.Provider, {
        value: {
            chosenFarmsMemoized: chosenFarmsMemoized
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmFlexWrapper, {
                    justifyContent: "space-between",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmH1, {
                                as: "h1",
                                scale: "xxl",
                                color: "secondary",
                                mb: "24px",
                                children: t("Shadow Farms")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmH2, {
                                scale: "lg",
                                color: "text",
                                children: t("Stake LP tokens to earn.")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ControlContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewControls, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleView/* default */.Z, {
                                        idPrefix: "clickFarm",
                                        viewMode: viewMode,
                                        onToggle: setViewMode
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle/* default */.Z, {
                                                id: "staked-only-farms",
                                                checked: stakedOnly,
                                                onChange: function() {
                                                    return setStakedOnly(!stakedOnly);
                                                },
                                                scale: "sm"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                children: [
                                                    " ",
                                                    t("Staked only")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle/* default */.Z, {
                                                id: "staked-only-farms",
                                                checked: boostedOnly,
                                                onChange: function() {
                                                    return setBoostedOnly(function(prev) {
                                                        return !prev;
                                                    });
                                                },
                                                scale: "sm"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                children: [
                                                    " ",
                                                    t("Booster Available")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FarmTabButtons, {
                                        hasStakeInFinishedFarms: stakedInactiveFarms.length > 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                textTransform: "uppercase",
                                                children: t("Sort by")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                options: [
                                                    {
                                                        label: t("Hot"),
                                                        value: "hot"
                                                    },
                                                    {
                                                        label: t("APR"),
                                                        value: "apr"
                                                    },
                                                    {
                                                        label: t("Multiplier"),
                                                        value: "multiplier"
                                                    },
                                                    {
                                                        label: t("Earned"),
                                                        value: "earned"
                                                    },
                                                    {
                                                        label: t("Liquidity"),
                                                        value: "liquidity"
                                                    },
                                                    {
                                                        label: t("Latest"),
                                                        value: "latest"
                                                    }, 
                                                ],
                                                onOptionChange: handleSortOptionChange
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelWrapper, {
                                        style: {
                                            marginLeft: 16
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                textTransform: "uppercase",
                                                children: t("Search")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput/* default */.Z, {
                                                initialValue: normalizedUrlSearch,
                                                onChange: handleChangeQuery,
                                                placeholder: "Search Farms"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    viewMode === actions/* ViewMode.TABLE */.wO.TABLE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_FarmTable, {
                        farms: chosenFarmsMemoized,
                        cakePrice: cakePrice,
                        userDataReady: userDataReady
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Flex/* default */.Z, {
                        children: children
                    }),
                    account && !userDataLoaded && stakedOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
                    }),
                    poolLength && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: observerRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                        src: "/images/decorations/plant3d.png",
                        alt: "Plant illustration",
                        width: 120,
                        height: 103
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollToTopButtonV2/* default */.Z, {}), document.body)
        ]
    });
};
var FarmsContext = /*#__PURE__*/ (0,react.createContext)({
    chosenFarmsMemoized: []
});
/* harmony default export */ var Farms_Farms = (Farms);


/***/ }),

/***/ 32921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7297);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44431);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(bignumber_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87379);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62077);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85937);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(27208);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(5389);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(89663);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(55078);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(62685);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(98553);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(63771);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(40735);
/* harmony import */ var components_Modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92176);
/* harmony import */ var components_RoiCalculatorModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92764);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52775);
/* harmony import */ var utils_formatBalance__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59123);
/* harmony import */ var utils_compoundApyHelpers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(42115);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
        "\n  width: 72px;\n  max-width: 72px;\n  overflow: hidden;\n  text-align: right;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var AnnualRoiContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7d48014a-0"
})(_templateObject());
var AnnualRoiDisplay = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7d48014a-1"
})(_templateObject1());
var DepositModal = function(param) {
    var max = param.max, stakedBalance = param.stakedBalance, onConfirm = param.onConfirm, onDismiss = param.onDismiss, _tokenName = param.tokenName, tokenName = _tokenName === void 0 ? "" : _tokenName, multiplier = param.multiplier, displayApr = param.displayApr, lpPrice = param.lpPrice, _lpLabel = param.lpLabel, lpLabel = _lpLabel === void 0 ? "" : _lpLabel, apr = param.apr, addLiquidityUrl = param.addLiquidityUrl, cakePrice = param.cakePrice, showActiveBooster = param.showActiveBooster;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), val = ref[0], setVal = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), pendingTx = ref1[0], setPendingTx = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), showRoiCalculator = ref2[0], setShowRoiCalculator = ref2[1];
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)().t;
    var fullBalance = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return (0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_8__/* .getFullDisplayBalance */ .NJ)(max);
    }, [
        max
    ]);
    var lpTokensToStake = new (bignumber_js__WEBPACK_IMPORTED_MODULE_3___default())(val);
    var fullBalanceNumber = new (bignumber_js__WEBPACK_IMPORTED_MODULE_3___default())(fullBalance);
    var usdToStake = lpTokensToStake.times(lpPrice);
    var interestBreakdown = (0,utils_compoundApyHelpers__WEBPACK_IMPORTED_MODULE_12__/* .getInterestBreakdown */ .A1)({
        principalInUSD: !lpTokensToStake.isNaN() ? usdToStake.toNumber() : 0,
        apr: apr,
        earningTokenPrice: cakePrice.toNumber()
    });
    var annualRoi = cakePrice.times(interestBreakdown[3]);
    var annualRoiAsNumber = annualRoi.toNumber();
    var formattedAnnualRoi = (0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_8__/* .formatNumber */ .uf)(annualRoiAsNumber, annualRoi.gt(10000) ? 0 : 2, annualRoi.gt(10000) ? 0 : 2);
    var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(e) {
        if (e.currentTarget.validity.valid) {
            setVal(e.currentTarget.value.replace(/,/g, "."));
        }
    }, [
        setVal
    ]);
    var handleSelectMax = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        setVal(fullBalance);
    }, [
        fullBalance,
        setVal
    ]);
    if (showRoiCalculator) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_RoiCalculatorModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            linkLabel: t("Get %symbol%", {
                symbol: lpLabel
            }),
            stakingTokenBalance: stakedBalance.plus(max),
            stakingTokenSymbol: tokenName,
            stakingTokenPrice: lpPrice.toNumber(),
            earningTokenPrice: cakePrice.toNumber(),
            apr: apr,
            multiplier: multiplier,
            displayApr: displayApr,
            linkHref: addLiquidityUrl,
            isFarm: true,
            initialValue: val,
            onBack: function() {
                return setShowRoiCalculator(false);
            }
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        title: t("Stake LP tokens"),
        onDismiss: onDismiss,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_Modal__WEBPACK_IMPORTED_MODULE_5__/* .ModalInput */ .S, {
                value: val,
                onSelectMax: handleSelectMax,
                onChange: handleChange,
                max: fullBalance,
                symbol: tokenName,
                addLiquidityUrl: addLiquidityUrl,
                inputTitle: t("Stake")
            }),
            showActiveBooster ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                variant: "warning",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    width: "24px",
                    color: "warning"
                }),
                mt: "32px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* .MessageText */ .Y, {
                    children: t("The yield booster multiplier will be updated based on the latest staking conditions.")
                })
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                mt: "24px",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        mr: "8px",
                        color: "textSubtle",
                        children: [
                            t("Annual ROI at current rates"),
                            ":"
                        ]
                    }),
                    Number.isFinite(annualRoiAsNumber) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(AnnualRoiContainer, {
                        alignItems: "center",
                        onClick: function() {
                            setShowRoiCalculator(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(AnnualRoiDisplay, {
                                children: [
                                    "$",
                                    formattedAnnualRoi
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                variant: "text",
                                scale: "sm",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    color: "textSubtle",
                                    width: "18px"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        width: 60
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(components_Modal__WEBPACK_IMPORTED_MODULE_5__/* .ModalActions */ .n, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        variant: "secondary",
                        onClick: onDismiss,
                        width: "100%",
                        disabled: pendingTx,
                        children: t("Cancel")
                    }),
                    pendingTx ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        width: "100%",
                        isLoading: pendingTx,
                        endIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                            spin: true,
                            color: "currentColor"
                        }),
                        children: t("Confirming")
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        width: "100%",
                        disabled: !lpTokensToStake.isFinite() || lpTokensToStake.eq(0) || lpTokensToStake.gt(fullBalanceNumber),
                        onClick: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        setPendingTx(true);
                                        _ctx.next = 3;
                                        return onConfirm(val);
                                    case 3:
                                        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                                        setPendingTx(false);
                                    case 5:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        })),
                        children: t("Confirm")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                href: addLiquidityUrl,
                style: {
                    alignSelf: "center"
                },
                children: t("Get %symbol%", {
                    symbol: tokenName
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DepositModal);


/***/ }),

/***/ 66140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87379);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21812);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88896);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62077);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(94998);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(89663);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(55078);
/* harmony import */ var components_RoiCalculatorModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92764);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52775);
/* harmony import */ var state_farms_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48674);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n\n  &:hover {\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ApyLabelContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a620fae9-0"
})(_templateObject());
var ApyButton = function(param) {
    var variant = param.variant, pid = param.pid, lpLabel = param.lpLabel, lpSymbol = param.lpSymbol, cakePrice = param.cakePrice, apr = param.apr, multiplier = param.multiplier, displayApr = param.displayApr, lpRewardsApr = param.lpRewardsApr, addLiquidityUrl = param.addLiquidityUrl, strikethrough = param.strikethrough, useTooltipText = param.useTooltipText, hideButton = param.hideButton;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var lpPrice = (0,state_farms_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useLpTokenPrice */ .w5)(lpSymbol);
    var ref = (0,state_farms_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useFarmUser */ .Dx)(pid), tokenBalance = ref.tokenBalance, stakedBalance = ref.stakedBalance;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_RoiCalculatorModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        linkLabel: t("Get %symbol%", {
            symbol: lpLabel
        }),
        stakingTokenBalance: stakedBalance.plus(tokenBalance),
        stakingTokenSymbol: lpSymbol,
        stakingTokenPrice: lpPrice.toNumber(),
        earningTokenPrice: cakePrice.toNumber(),
        apr: apr,
        multiplier: multiplier,
        displayApr: displayApr,
        linkHref: addLiquidityUrl,
        isFarm: true
    })), 1), onPresentApyModal = ref1[0];
    var handleClickButton = function(event) {
        event.stopPropagation();
        onPresentApyModal();
    };
    var ref2 = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                children: [
                    t("APR (incl. LP rewards)"),
                    ":",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        style: {
                            display: "inline-block"
                        },
                        color: strikethrough && "secondary",
                        children: strikethrough ? "".concat((apr * 2 + lpRewardsApr).toFixed(2), "%") : "".concat(displayApr, "%")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                ml: "5px",
                children: [
                    "*",
                    t("Base APR (SHDW yield only)"),
                    ":",
                    " ",
                    strikethrough ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        style: {
                            display: "inline-block"
                        },
                        color: "secondary",
                        children: "".concat((apr * 2).toFixed(2), "%")
                    }) : "".concat(apr.toFixed(2), "%")
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                ml: "5px",
                children: [
                    "*",
                    t("LP Rewards APR"),
                    ": ",
                    lpRewardsApr === 0 ? "-" : lpRewardsApr,
                    "%"
                ]
            }),
            strikethrough && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                color: "secondary",
                children: t("Available Boosted: Up to 2x")
            }),
            strikethrough && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                color: "secondary",
                children: t("Boost only applies to base APR (SHDW yield)")
            })
        ]
    }), {
        placement: "top"
    }), targetRef = ref2.targetRef, tooltip = ref2.tooltip, tooltipVisible = ref2.tooltipVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        flexDirection: "column",
        alignItems: "flex-start",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ApyLabelContainer, {
            alignItems: "center",
            onClick: function(event) {
                if (hideButton) return;
                handleClickButton(event);
            },
            style: strikethrough && {
                textDecoration: "line-through"
            },
            children: [
                useTooltipText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            ref: targetRef,
                            decorationColor: "secondary",
                            children: [
                                displayApr,
                                "%"
                            ]
                        }),
                        tooltipVisible && tooltip
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        displayApr,
                        "%"
                    ]
                }),
                variant === "text-and-button" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    variant: "text",
                    scale: "sm",
                    ml: "4px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        width: "18px"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ApyButton);


/***/ }),

/***/ 58024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FarmCard_FarmCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(20353);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(62685);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var src = __webpack_require__(52775);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronUp.tsx
var ChevronUp = __webpack_require__(1274);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(57049);
;// CONCATENATED MODULE: ./src/components/ExpandableSectionButton/ExpandableSectionButton.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  svg {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c6e111d3-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var ExpandableSectionButton = function(param) {
    var onClick = param.onClick, _expanded = param.expanded, expanded = _expanded === void 0 ? false : _expanded;
    var t = (0,src/* useTranslation */.$G)().t;
    var handleOnClick = (0,react.useCallback)(function() {
        return onClick === null || onClick === void 0 ? void 0 : onClick();
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        "aria-label": t("Hide or show expandable content"),
        role: "button",
        onClick: handleOnClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "primary",
                bold: true,
                children: expanded ? t("Hide") : t("Details")
            }),
            expanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUp/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var ExpandableSectionButton_ExpandableSectionButton = (ExpandableSectionButton);

;// CONCATENATED MODULE: ./src/components/ExpandableSectionButton/index.ts


// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(97478);
// EXTERNAL MODULE: ./src/utils/getLiquidityUrlPathParts.ts
var getLiquidityUrlPathParts = __webpack_require__(88100);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(40735);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/DetailsSection.tsx

function DetailsSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n"
    ]);
    DetailsSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var DetailsSection_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-adc092b5-0"
})(DetailsSection_templateObject());
var StyledLinkExternal = (0,styled_components_browser_esm/* default */.ZP)(LinkExternal/* default */.Z).withConfig({
    componentId: "sc-adc092b5-1"
})(_templateObject1());
var DetailsSection = function(param) {
    var bscScanAddress = param.bscScanAddress, infoAddress = param.infoAddress, removed = param.removed, totalValueFormatted = param.totalValueFormatted, lpLabel = param.lpLabel, addLiquidityUrl = param.addLiquidityUrl, isCommunity = param.isCommunity, auctionHostingEndDate = param.auctionHostingEndDate;
    var ref = (0,src/* useTranslation */.$G)(), t = ref.t, locale = ref.currentLanguage.locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsSection_Wrapper, {
        children: [
            isCommunity && auctionHostingEndDate && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        children: [
                            t("Auction Hosting Ends"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: new Date(auctionHostingEndDate).toLocaleString(locale, {
                            month: "short",
                            day: "numeric",
                            year: "numeric"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        children: [
                            t("Total Liquidity"),
                            ":"
                        ]
                    }),
                    totalValueFormatted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: totalValueFormatted
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 75,
                        height: 25
                    })
                ]
            }),
            !removed && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkExternal, {
                href: addLiquidityUrl,
                children: t("Get %symbol%", {
                    symbol: lpLabel
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkExternal, {
                href: bscScanAddress,
                children: t("View Contract")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkExternal, {
                href: infoAddress,
                children: t("See Pair Info")
            })
        ]
    });
};
/* harmony default export */ var FarmCard_DetailsSection = (DetailsSection);

// EXTERNAL MODULE: ./packages/uikit/src/components/Tag/Tag.tsx + 3 modules
var Tag = __webpack_require__(22769);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(69589);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./src/components/Tags.tsx
var Tags = __webpack_require__(32675);
// EXTERNAL MODULE: ./src/components/TokenImage/index.tsx
var TokenImage = __webpack_require__(39023);
// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/components/BoostedTag.tsx
var BoostedTag = __webpack_require__(39085);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/CardHeading.tsx

function CardHeading_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  svg {\n    margin-right: 4px;\n  }\n"
    ]);
    CardHeading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CardHeading_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 4px;\n"
    ]);
    CardHeading_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var CardHeading_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-9f68de1-0"
})(CardHeading_templateObject());
var MultiplierTag = (0,styled_components_browser_esm/* default */.ZP)(Tag/* default */.Z).withConfig({
    componentId: "sc-9f68de1-1"
})(CardHeading_templateObject1());
var CardHeading = function(param) {
    var lpLabel = param.lpLabel, multiplier = param.multiplier, isCommunityFarm = param.isCommunityFarm, token = param.token, quoteToken = param.quoteToken, boosted = param.boosted;
    var isReady = multiplier !== undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardHeading_Wrapper, {
        justifyContent: "space-between",
        alignItems: "center",
        mb: "12px",
        children: [
            isReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenImage/* TokenPairImage */.q, {
                variant: "inverted",
                primaryToken: token,
                secondaryToken: quoteToken,
                width: 64,
                height: 64
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                mr: "8px",
                width: 63,
                height: 63,
                variant: "circle"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                alignItems: "flex-end",
                children: [
                    isReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        mb: "4px",
                        children: lpLabel.split(" ")[0]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        mb: "4px",
                        width: 60,
                        height: 18
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "center",
                        children: [
                            isReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                children: isCommunityFarm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags/* FarmAuctionTag */.Vi, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags/* CoreTag */.eE, {})
                            }) : null,
                            boosted && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoostedTag/* default */.Z, {
                                ml: "4px"
                            }),
                            isReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiplierTag, {
                                variant: "secondary",
                                children: multiplier
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                ml: "4px",
                                width: 42,
                                height: 28
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FarmCard_CardHeading = (CardHeading);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx + 1 modules
var ConnectWalletButton = __webpack_require__(72409);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(19237);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(88896);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var TooltipText = __webpack_require__(94998);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(98553);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var wagmi_src = __webpack_require__(29315);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./src/components/Balance.tsx
var Balance = __webpack_require__(18778);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 1 modules
var Toast = __webpack_require__(96036);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(76431);
// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 1 modules
var hooks = __webpack_require__(48674);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(87318);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/HarvestAction.tsx













var HarvestAction = function(param) {
    var earnings = param.earnings, onReward = param.onReward, proxyCakeBalance = param.proxyCakeBalance, onDone = param.onDone;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var t = (0,src/* useTranslation */.$G)().t;
    var cakePrice = (0,hooks/* usePriceCakeBusd */.Iu)();
    var rawEarningsBalance = account ? (0,formatBalance/* getBalanceAmount */.U4)(earnings) : bigNumber/* BIG_ZERO */.HW;
    var displayBalance = rawEarningsBalance.toFixed(5, (bignumber_default()).ROUND_DOWN);
    var earningsBusd = rawEarningsBalance ? rawEarningsBalance.multipliedBy(cakePrice).toNumber() : 0;
    var tooltipBalance = rawEarningsBalance.isGreaterThan(new (bignumber_default())(0.00001)) ? displayBalance : "< 0.00001";
    var ref1 = (0,useTooltip/* default */.Z)("".concat(tooltipBalance, " ").concat(t("SHDW has been harvested to the farm booster contract and will be automatically sent to your wallet upon the next harvest.")), {
        placement: "bottom"
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        mb: "8px",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                alignItems: "flex-start",
                children: [
                    proxyCakeBalance ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                                ref: targetRef,
                                decorationColor: "secondary",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    color: rawEarningsBalance.eq(0) ? "textDisabled" : "text",
                                    children: displayBalance
                                })
                            }),
                            tooltipVisible && tooltip
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        color: rawEarningsBalance.eq(0) ? "textDisabled" : "text",
                        children: displayBalance
                    }),
                    earningsBusd > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        fontSize: "12px",
                        color: "textSubtle",
                        decimals: 2,
                        value: earningsBusd,
                        unit: " USD",
                        prefix: "~"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                disabled: rawEarningsBalance.eq(0) || pendingTx,
                onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var receipt;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return fetchWithCatchTxError(function() {
                                    return onReward();
                                });
                            case 2:
                                receipt = _ctx.sent;
                                if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                                    toastSuccess("".concat(t("Harvested"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                        txHash: receipt.transactionHash,
                                        children: t("Your %symbol% earnings have been sent to your wallet!", {
                                            symbol: "SHDW"
                                        })
                                    }));
                                    onDone === null || onDone === void 0 ? void 0 : onDone();
                                }
                            case 4:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                })),
                children: pendingTx ? t("Harvesting") : t("Harvest")
            })
        ]
    });
};
/* harmony default export */ var FarmCard_HarvestAction = (HarvestAction);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(21812);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(89663);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Minus.tsx
var Minus = __webpack_require__(2412);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Add.tsx
var Add = __webpack_require__(96484);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/views/Farms/components/DepositModal.tsx
var DepositModal = __webpack_require__(32921);
// EXTERNAL MODULE: ./src/views/Farms/components/StakedLP.tsx
var StakedLP = __webpack_require__(36508);
// EXTERNAL MODULE: ./src/views/Farms/components/WithdrawModal.tsx
var WithdrawModal = __webpack_require__(6105);
// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/components/ProxyFarmContainer.tsx
var ProxyFarmContainer = __webpack_require__(28696);
// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/hooks/useYieldBoosterState.ts + 2 modules
var useYieldBoosterState = __webpack_require__(86598);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/StakeAction.tsx




function StakeAction_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  svg {\n    width: 20px;\n  }\n"
    ]);
    StakeAction_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var IconButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a19c0c96-0"
})(StakeAction_templateObject());
var StakeAction = function(param) {
    var quoteToken = param.quoteToken, token = param.token, lpSymbol = param.lpSymbol, multiplier = param.multiplier, apr = param.apr, displayApr = param.displayApr, addLiquidityUrl = param.addLiquidityUrl, lpLabel = param.lpLabel, lpTotalSupply = param.lpTotalSupply, tokenAmountTotal = param.tokenAmountTotal, quoteTokenAmountTotal = param.quoteTokenAmountTotal, userData = param.userData, onStake = param.onStake, onUnstake = param.onUnstake, onDone = param.onDone, onApprove = param.onApprove, isApproved = param.isApproved;
    var t = (0,src/* useTranslation */.$G)().t;
    var tokenBalance = userData.tokenBalance, stakedBalance = userData.stakedBalance;
    var cakePrice = (0,hooks/* usePriceCakeBusd */.Iu)();
    var router = (0,next_router.useRouter)();
    var lpPrice = (0,hooks/* useLpTokenPrice */.w5)(lpSymbol);
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var boosterState = (0,react.useContext)(ProxyFarmContainer/* YieldBoosterStateContext */._).boosterState;
    var handleStake = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(amount) {
            var receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchWithCatchTxError(function() {
                            return onStake(amount);
                        });
                    case 2:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess("".concat(t("Staked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                txHash: receipt.transactionHash,
                                children: t("Your funds have been staked in the farm")
                            }));
                            onDone();
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleStake(amount) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUnstake = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(amount) {
            var receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchWithCatchTxError(function() {
                            return onUnstake(amount);
                        });
                    case 2:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess("".concat(t("Unstaked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                txHash: receipt.transactionHash,
                                children: t("Your earnings have also been harvested to your wallet")
                            }));
                            onDone();
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleUnstake(amount) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleApprove = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var receipt;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchWithCatchTxError(function() {
                        return onApprove();
                    });
                case 2:
                    receipt = _ctx.sent;
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Contract Enabled"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash
                        }));
                        onDone();
                    }
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        onApprove,
        t,
        toastSuccess,
        fetchWithCatchTxError,
        onDone
    ]);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(DepositModal/* default */.Z, {
        max: tokenBalance,
        stakedBalance: stakedBalance,
        onConfirm: handleStake,
        tokenName: lpSymbol,
        multiplier: multiplier,
        lpPrice: lpPrice,
        lpLabel: lpLabel,
        apr: apr,
        displayApr: displayApr,
        addLiquidityUrl: addLiquidityUrl,
        cakePrice: cakePrice,
        showActiveBooster: boosterState === useYieldBoosterState/* YieldBoosterState.ACTIVE */.M.ACTIVE
    })), 1), onPresentDeposit = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(WithdrawModal/* default */.Z, {
        showActiveBooster: boosterState === useYieldBoosterState/* YieldBoosterState.ACTIVE */.M.ACTIVE,
        max: stakedBalance,
        onConfirm: handleUnstake,
        tokenName: lpSymbol
    })), 1), onPresentWithdraw = ref2[0];
    var renderStakingButtons = function() {
        return stakedBalance.eq(0) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            onClick: onPresentDeposit,
            disabled: [
                "history",
                "archived"
            ].some(function(item) {
                return router.pathname.includes(item);
            }),
            children: t("Stake LP")
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButtonWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    variant: "tertiary",
                    onClick: onPresentWithdraw,
                    mr: "6px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {
                        color: "primary",
                        width: "14px"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    variant: "tertiary",
                    onClick: onPresentDeposit,
                    disabled: [
                        "history",
                        "archived"
                    ].some(function(item) {
                        return router.pathname.includes(item);
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                        color: "primary",
                        width: "14px"
                    })
                })
            ]
        });
    };
    // TODO: Move this out to prevent unnecessary re-rendered
    if (!isApproved) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            mt: "8px",
            width: "100%",
            disabled: pendingTx,
            onClick: handleApprove,
            children: t("Enable Contract")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justifyContent: "space-between",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StakedLP/* default */.Z, {
                stakedBalance: stakedBalance,
                lpSymbol: lpSymbol,
                quoteTokenSymbol: quoteToken.symbol,
                tokenSymbol: token.symbol,
                lpTotalSupply: lpTotalSupply,
                tokenAmountTotal: tokenAmountTotal,
                quoteTokenAmountTotal: quoteTokenAmountTotal
            }),
            renderStakingButtons()
        ]
    });
};
/* harmony default export */ var FarmCard_StakeAction = (StakeAction);

// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/components/BoostedAction.tsx + 5 modules
var BoostedAction = __webpack_require__(62006);
// EXTERNAL MODULE: ./src/views/Farms/components/FarmTable/Actions/HarvestAction.tsx + 1 modules
var Actions_HarvestAction = __webpack_require__(4679);
// EXTERNAL MODULE: ./src/views/Farms/components/FarmTable/Actions/StakedAction.tsx + 1 modules
var StakedAction = __webpack_require__(32624);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/CardActionsContainer.tsx



function CardActionsContainer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 16px;\n"
    ]);
    CardActionsContainer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CardActionsContainer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    CardActionsContainer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var Action = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-76889977-0"
})(CardActionsContainer_templateObject());
var ActionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-76889977-1"
})(CardActionsContainer_templateObject1());
var CardActions = function(param) {
    var farm = param.farm, account = param.account, addLiquidityUrl = param.addLiquidityUrl, lpLabel = param.lpLabel, displayApr = param.displayApr;
    var t = (0,src/* useTranslation */.$G)().t;
    var pid = farm.pid, lpAddress = farm.lpAddress;
    var earnings = (farm.userData || {}).earnings;
    var shouldUseProxyFarm = (0,react.useContext)(ProxyFarmContainer/* YieldBoosterStateContext */._).shouldUseProxyFarm;
    var isReady = farm.multiplier !== undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Action, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        textTransform: "uppercase",
                        color: "secondary",
                        fontSize: "12px",
                        pr: "4px",
                        children: "SHDW"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        textTransform: "uppercase",
                        color: "textSubtle",
                        fontSize: "12px",
                        children: t("Earned")
                    })
                ]
            }),
            shouldUseProxyFarm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Actions_HarvestAction/* ProxyHarvestActionContainer */.nG, {
                earnings: earnings,
                pid: pid,
                lpAddress: lpAddress,
                children: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_HarvestAction, (0,_object_spread/* default */.Z)({}, props));
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Actions_HarvestAction/* HarvestActionContainer */.ln, {
                earnings: earnings,
                pid: pid,
                children: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_HarvestAction, (0,_object_spread/* default */.Z)({}, props));
                }
            }),
            farm.boosted && /*#__PURE__*/ (0,jsx_runtime.jsx)(BoostedAction/* default */.Z, {
                title: function(status) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                textTransform: "uppercase",
                                color: "textSubtle",
                                fontSize: "12px",
                                pr: "4px",
                                children: t("Yield Booster")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                textTransform: "uppercase",
                                color: "secondary",
                                fontSize: "12px",
                                children: status
                            })
                        ]
                    });
                },
                desc: function(actionBtn) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionContainer, {
                        children: actionBtn
                    });
                },
                farmPid: farm.pid
            }),
            isReady ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        textTransform: "uppercase",
                        color: "secondary",
                        fontSize: "12px",
                        pr: "4px",
                        children: farm.lpSymbol
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        textTransform: "uppercase",
                        color: "textSubtle",
                        fontSize: "12px",
                        children: t("Staked")
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                width: 80,
                height: 18,
                mb: "4px"
            }),
            !account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                mt: "8px",
                width: "100%"
            }) : shouldUseProxyFarm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StakedAction/* ProxyStakedContainer */.sf, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, farm), {
                lpLabel: lpLabel,
                addLiquidityUrl: addLiquidityUrl,
                displayApr: displayApr,
                children: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_StakeAction, (0,_object_spread/* default */.Z)({}, props));
                }
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StakedAction/* StakedContainer */.pK, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, farm), {
                lpLabel: lpLabel,
                addLiquidityUrl: addLiquidityUrl,
                displayApr: displayApr,
                children: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_StakeAction, (0,_object_spread/* default */.Z)({}, props));
                }
            }))
        ]
    });
};
/* harmony default export */ var CardActionsContainer = (CardActions);

// EXTERNAL MODULE: ./src/views/Farms/components/FarmCard/ApyButton.tsx
var ApyButton = __webpack_require__(66140);
// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/components/BoostedApr.tsx
var BoostedApr = __webpack_require__(52914);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/FarmCard.tsx

function FarmCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: baseline;\n  max-width: 100%;\n  margin: 0 0 24px 0;\n  ",
        " {\n    max-width: 350px;\n    margin: 0 12px 46px;\n  }\n"
    ]);
    FarmCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FarmCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  justify-content: space-around;\n  padding: 24px;\n"
    ]);
    FarmCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n  border-top: 2px solid ",
        ";\n  overflow: hidden;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}















var StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-16a37824-0"
})(FarmCard_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var FarmCardInnerContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-16a37824-1"
})(FarmCard_templateObject1());
var ExpandingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-16a37824-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var FarmCard = function(param) {
    var farm = param.farm, displayApr = param.displayApr, removed = param.removed, cakePrice = param.cakePrice, account = param.account, originalLiquidity = param.originalLiquidity;
    var t = (0,src/* useTranslation */.$G)().t;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var ref = (0,react.useState)(false), showExpandableSection = ref[0], setShowExpandableSection = ref[1];
    var liquidity = (farm === null || farm === void 0 ? void 0 : farm.liquidity) && (originalLiquidity === null || originalLiquidity === void 0 ? void 0 : originalLiquidity.gt(0)) ? farm.liquidity.plus(originalLiquidity) : farm.liquidity;
    var totalValueFormatted = liquidity && liquidity.gt(0) ? "$".concat(liquidity.toNumber().toLocaleString(undefined, {
        maximumFractionDigits: 0
    })) : "";
    var lpLabel = farm.lpSymbol && farm.lpSymbol.toUpperCase().replace("SHADOW", "");
    var earnLabel = farm.dual ? farm.dual.earnLabel : t("SHDW + Fees");
    var liquidityUrlPathParts = (0,getLiquidityUrlPathParts/* default */.Z)({
        quoteTokenAddress: farm.quoteToken.address,
        tokenAddress: farm.token.address
    });
    var addLiquidityUrl = "".concat(config/* BASE_ADD_LIQUIDITY_URL */.wI, "/").concat(liquidityUrlPathParts);
    var lpAddress = farm.lpAddress;
    var isPromotedFarm = farm.token.symbol === "SHDW";
    var toggleExpandableSection = (0,react.useCallback)(function() {
        setShowExpandableSection(function(prev) {
            return !prev;
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
        isActive: isPromotedFarm,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FarmCardInnerContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_CardHeading, {
                        lpLabel: lpLabel,
                        multiplier: farm.multiplier,
                        isCommunityFarm: farm.isCommunity,
                        token: farm.token,
                        quoteToken: farm.quoteToken,
                        boosted: farm.boosted
                    }),
                    !removed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                children: [
                                    t("APR"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                style: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: farm.apr ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        farm.boosted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BoostedApr/* default */.Z, {
                                            mr: "4px",
                                            lpRewardsApr: farm.lpRewardsApr,
                                            apr: farm.apr,
                                            pid: farm === null || farm === void 0 ? void 0 : farm.pid
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ApyButton/* default */.Z, {
                                            variant: "text-and-button",
                                            pid: farm.pid,
                                            lpSymbol: farm.lpSymbol,
                                            multiplier: farm.multiplier,
                                            lpLabel: lpLabel,
                                            addLiquidityUrl: addLiquidityUrl,
                                            cakePrice: cakePrice,
                                            apr: farm.apr,
                                            displayApr: displayApr,
                                            lpRewardsApr: farm.lpRewardsApr,
                                            strikethrough: farm.boosted
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    height: 24,
                                    width: 80
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                children: [
                                    t("Earn"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                children: earnLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionsContainer, {
                        farm: farm,
                        lpLabel: lpLabel,
                        account: account,
                        addLiquidityUrl: addLiquidityUrl,
                        displayApr: displayApr
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExpandingWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableSectionButton_ExpandableSectionButton, {
                        onClick: toggleExpandableSection,
                        expanded: showExpandableSection
                    }),
                    showExpandableSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_DetailsSection, {
                        removed: removed,
                        bscScanAddress: (0,utils/* getBlockExploreLink */.C)(lpAddress, "address", chainId),
                        infoAddress: "/info/pool/".concat(lpAddress),
                        totalValueFormatted: totalValueFormatted,
                        lpLabel: lpLabel,
                        addLiquidityUrl: addLiquidityUrl,
                        isCommunity: farm.isCommunity,
                        auctionHostingEndDate: farm.auctionHostingEndDate
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FarmCard_FarmCard = (FarmCard);


/***/ }),

/***/ 4679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xO": function() { return /* binding */ HarvestAction; },
  "ln": function() { return /* binding */ HarvestActionContainer; },
  "nG": function() { return /* binding */ ProxyHarvestActionContainer; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var src = __webpack_require__(52775);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(19237);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(62685);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(88896);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var TooltipText = __webpack_require__(94998);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(69589);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(98553);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./src/components/Balance.tsx
var Balance = __webpack_require__(18778);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 1 modules
var Toast = __webpack_require__(96036);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(76431);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(36963);
// EXTERNAL MODULE: ./src/state/index.ts + 31 modules
var state = __webpack_require__(2154);
// EXTERNAL MODULE: ./src/state/farms/index.ts + 10 modules
var farms = __webpack_require__(14425);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 1 modules
var hooks = __webpack_require__(48674);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(87318);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
// EXTERNAL MODULE: ./src/utils/calls/index.ts + 2 modules
var calls = __webpack_require__(56946);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(921);
;// CONCATENATED MODULE: ./src/views/Farms/hooks/useHarvestFarm.ts






var useHarvestFarm = function(farmPid) {
    var masterChefContract = (0,useContract/* useMasterchef */.y8)();
    var gasPrice = (0,user_hooks/* useGasPrice */.Fh)();
    var handleHarvest = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,calls/* harvestFarm */.sA)(masterChefContract, farmPid, gasPrice));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        farmPid,
        masterChefContract,
        gasPrice
    ]);
    return {
        onReward: handleHarvest
    };
};
/* harmony default export */ var hooks_useHarvestFarm = (useHarvestFarm);

// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/hooks/useProxyStakedActions.ts + 1 modules
var useProxyStakedActions = __webpack_require__(46791);
// EXTERNAL MODULE: ./src/views/Farms/components/FarmTable/Actions/styles.ts
var styles = __webpack_require__(5563);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Actions/HarvestAction.tsx























var ProxyHarvestActionContainer = function(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var lpAddress = props.lpAddress;
    var lpContract = (0,useContract/* useERC20 */.X_)(lpAddress);
    var ref = (0,useProxyStakedActions/* default */.Z)(props.pid, lpContract), onReward = ref.onReward, onDone = ref.onDone, proxyCakeBalance = ref.proxyCakeBalance;
    return children((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        onReward: onReward,
        proxyCakeBalance: proxyCakeBalance,
        onDone: onDone
    }));
};
var HarvestActionContainer = function(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var onReward = hooks_useHarvestFarm(props.pid).onReward;
    var ref = (0,useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var onDone = (0,react.useCallback)(function() {
        return dispatch((0,farms/* fetchFarmUserDataAsync */.IV)({
            account: account,
            pids: [
                props.pid
            ],
            chainId: chainId
        }));
    }, [
        account,
        dispatch,
        chainId,
        props.pid
    ]);
    return children((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        onDone: onDone,
        onReward: onReward
    }));
};
var HarvestAction = function(param) {
    var onReward = param.onReward, onDone = param.onDone, userData = param.userData, userDataReady = param.userDataReady, proxyCakeBalance = param.proxyCakeBalance;
    var t = (0,src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var earningsBigNumber = new (bignumber_default())(userData.earnings);
    var cakePrice = (0,hooks/* usePriceCakeBusd */.Iu)();
    var earnings = bigNumber/* BIG_ZERO */.HW;
    var earningsBusd = 0;
    var displayBalance = userDataReady ? earnings.toFixed(5, (bignumber_default()).ROUND_DOWN) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        width: 60
    });
    // If user didn't connect wallet default balance will be 0
    if (!earningsBigNumber.isZero()) {
        earnings = (0,formatBalance/* getBalanceAmount */.U4)(earningsBigNumber);
        earningsBusd = earnings.multipliedBy(cakePrice).toNumber();
        displayBalance = earnings.toFixed(5, (bignumber_default()).ROUND_DOWN);
    }
    var toolTipBalance = !userDataReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        width: 60
    }) : earnings.isGreaterThan(new (bignumber_default())(0.00001)) ? earnings.toFixed(5, (bignumber_default()).ROUND_DOWN) : "< 0.00001";
    var ref1 = (0,useTooltip/* default */.Z)("".concat(toolTipBalance, " ").concat(t("CAKE has been harvested to the farm booster contract and will be automatically sent to your wallet upon the next harvest.")), {
        placement: "bottom"
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ActionContainer */.sX, {
        style: {
            minHeight: 124.5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ActionTitles */.Ad, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        textTransform: "uppercase",
                        color: "secondary",
                        fontSize: "12px",
                        pr: "4px",
                        children: "SHDW"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        textTransform: "uppercase",
                        color: "textSubtle",
                        fontSize: "12px",
                        children: t("Earned")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ActionContent */.O6, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            proxyCakeBalance ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                                        ref: targetRef,
                                        decorationColor: "secondary",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            children: displayBalance
                                        })
                                    }),
                                    tooltipVisible && tooltip
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                children: displayBalance
                            }),
                            earningsBusd > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                decimals: 2,
                                value: earningsBusd,
                                unit: " USD",
                                prefix: "~"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        disabled: earnings.eq(0) || pendingTx || !userDataReady,
                        onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                            var receipt;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.next = 2;
                                        return fetchWithCatchTxError(function() {
                                            return onReward();
                                        });
                                    case 2:
                                        receipt = _ctx.sent;
                                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                                            toastSuccess("".concat(t("Harvested"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                                txHash: receipt.transactionHash,
                                                children: t("Your %symbol% earnings have been sent to your wallet!", {
                                                    symbol: "SHDW"
                                                })
                                            }));
                                            onDone === null || onDone === void 0 ? void 0 : onDone();
                                        }
                                    case 4:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        })),
                        ml: "4px",
                        children: pendingTx ? t("Harvesting") : t("Harvest")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Actions_HarvestAction = ((/* unused pure expression or super */ null && (HarvestAction)));


/***/ }),

/***/ 32624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sf": function() { return /* binding */ ProxyStakedContainer; },
  "pK": function() { return /* binding */ StakedContainer; },
  "ZP": function() { return /* binding */ StakedAction; }
});

// UNUSED EXPORTS: useStakedActions

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var src = __webpack_require__(52775);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(19237);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(21812);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(89663);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Minus.tsx
var Minus = __webpack_require__(2412);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Add.tsx
var Add = __webpack_require__(96484);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(98553);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(62685);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx + 1 modules
var ConnectWalletButton = __webpack_require__(72409);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 1 modules
var Toast = __webpack_require__(96036);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(97478);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(76431);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(36963);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/state/index.ts + 31 modules
var state = __webpack_require__(2154);
// EXTERNAL MODULE: ./src/state/farms/index.ts + 10 modules
var farms = __webpack_require__(14425);
// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 1 modules
var hooks = __webpack_require__(48674);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/utils/getLiquidityUrlPathParts.ts
var getLiquidityUrlPathParts = __webpack_require__(88100);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useApproveFarm.ts
var useApproveFarm = __webpack_require__(30685);
// EXTERNAL MODULE: ./src/utils/calls/index.ts + 2 modules
var calls = __webpack_require__(56946);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(921);
;// CONCATENATED MODULE: ./src/views/Farms/hooks/useStakeFarms.ts






var useStakeFarms = function(pid) {
    var masterChefContract = (0,useContract/* useMasterchef */.y8)();
    var gasPrice = (0,user_hooks/* useGasPrice */.Fh)();
    var handleStake = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(amount) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", (0,calls/* stakeFarm */.AQ)(masterChefContract, pid, amount, gasPrice));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(amount) {
            return _ref.apply(this, arguments);
        };
    }(), [
        masterChefContract,
        pid,
        gasPrice
    ]);
    return {
        onStake: handleStake
    };
};
/* harmony default export */ var hooks_useStakeFarms = (useStakeFarms);

// EXTERNAL MODULE: ./src/views/Farms/hooks/useUnstakeFarms.ts
var useUnstakeFarms = __webpack_require__(7938);
// EXTERNAL MODULE: ./src/views/Farms/components/DepositModal.tsx
var DepositModal = __webpack_require__(32921);
// EXTERNAL MODULE: ./src/views/Farms/components/StakedLP.tsx
var StakedLP = __webpack_require__(36508);
// EXTERNAL MODULE: ./src/views/Farms/components/WithdrawModal.tsx
var WithdrawModal = __webpack_require__(6105);
// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/components/ProxyFarmContainer.tsx
var ProxyFarmContainer = __webpack_require__(28696);
// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/hooks/useProxyStakedActions.ts + 1 modules
var useProxyStakedActions = __webpack_require__(46791);
// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/hooks/useYieldBoosterState.ts + 2 modules
var useYieldBoosterState = __webpack_require__(86598);
// EXTERNAL MODULE: ./src/views/Farms/components/FarmTable/Actions/styles.ts
var styles = __webpack_require__(5563);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Actions/StakedAction.tsx







function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:nth-child(3) {\n    flex-basis: 100%;\n  }\n  min-height: 124.5px;\n  ",
        " {\n    &:nth-child(3) {\n      margin-top: 16px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


























var IconButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bd128858-0"
})(_templateObject());
var StyledActionContainer = (0,styled_components_browser_esm/* default */.ZP)(styles/* ActionContainer */.sX).withConfig({
    componentId: "sc-bd128858-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
function useStakedActions(pid, lpContract) {
    var ref = (0,useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var onStake = hooks_useStakeFarms(pid).onStake;
    var onUnstake = (0,useUnstakeFarms/* default */.Z)(pid).onUnstake;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var onApprove = (0,useApproveFarm/* default */.Z)(lpContract, chainId).onApprove;
    var onDone = (0,react.useCallback)(function() {
        return dispatch((0,farms/* fetchFarmUserDataAsync */.IV)({
            account: account,
            pids: [
                pid
            ],
            chainId: chainId
        }));
    }, [
        account,
        pid,
        chainId,
        dispatch
    ]);
    return {
        onStake: onStake,
        onUnstake: onUnstake,
        onApprove: onApprove,
        onDone: onDone
    };
}
var ProxyStakedContainer = function(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var lpAddress = props.lpAddress;
    var lpContract = (0,useContract/* useERC20 */.X_)(lpAddress);
    var ref = (0,useProxyStakedActions/* default */.Z)(props.pid, lpContract), onStake = ref.onStake, onUnstake = ref.onUnstake, onApprove = ref.onApprove, onDone = ref.onDone;
    var allowance = (props.userData || {}).allowance;
    var isApproved = account && allowance && allowance.isGreaterThan(0);
    return children((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        onStake: onStake,
        onDone: onDone,
        onUnstake: onUnstake,
        onApprove: onApprove,
        isApproved: isApproved
    }));
};
var StakedContainer = function(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var lpAddress = props.lpAddress;
    var lpContract = (0,useContract/* useERC20 */.X_)(lpAddress);
    var ref = useStakedActions(props.pid, lpContract), onStake = ref.onStake, onUnstake = ref.onUnstake, onApprove = ref.onApprove, onDone = ref.onDone;
    var allowance = (props.userData || {}).allowance;
    var isApproved = account && allowance && allowance.isGreaterThan(0);
    return children((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        onStake: onStake,
        onDone: onDone,
        onUnstake: onUnstake,
        onApprove: onApprove,
        isApproved: isApproved
    }));
};
var Staked = function(param) {
    var apr = param.apr, multiplier = param.multiplier, lpSymbol = param.lpSymbol, lpLabel = param.lpLabel, quoteToken = param.quoteToken, token = param.token, userDataReady = param.userDataReady, displayApr = param.displayApr, lpTotalSupply = param.lpTotalSupply, tokenAmountTotal = param.tokenAmountTotal, quoteTokenAmountTotal = param.quoteTokenAmountTotal, userData = param.userData, onDone = param.onDone, onStake = param.onStake, onUnstake = param.onUnstake, onApprove = param.onApprove, isApproved = param.isApproved;
    var boosterState = (0,react.useContext)(ProxyFarmContainer/* YieldBoosterStateContext */._).boosterState;
    var t = (0,src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var ref1 = userData || {}, tokenBalance = ref1.tokenBalance, stakedBalance = ref1.stakedBalance;
    var router = (0,next_router.useRouter)();
    var lpPrice = (0,hooks/* useLpTokenPrice */.w5)(lpSymbol);
    var cakePrice = (0,hooks/* usePriceCakeBusd */.Iu)();
    var liquidityUrlPathParts = (0,getLiquidityUrlPathParts/* default */.Z)({
        quoteTokenAddress: quoteToken.address,
        tokenAddress: token.address
    });
    var addLiquidityUrl = "".concat(config/* BASE_ADD_LIQUIDITY_URL */.wI, "/").concat(liquidityUrlPathParts);
    var handleStake = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(amount) {
            var receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchWithCatchTxError(function() {
                            return onStake(amount);
                        });
                    case 2:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess("".concat(t("Staked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                txHash: receipt.transactionHash,
                                children: t("Your funds have been staked in the farm")
                            }));
                            onDone();
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleStake(amount) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUnstake = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(amount) {
            var receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchWithCatchTxError(function() {
                            return onUnstake(amount);
                        });
                    case 2:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess("".concat(t("Unstaked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                txHash: receipt.transactionHash,
                                children: t("Your earnings have also been harvested to your wallet")
                            }));
                            onDone();
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleUnstake(amount) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(DepositModal/* default */.Z, {
        max: tokenBalance,
        lpPrice: lpPrice,
        lpLabel: lpLabel,
        apr: apr,
        displayApr: displayApr,
        stakedBalance: stakedBalance,
        onConfirm: handleStake,
        tokenName: lpSymbol,
        multiplier: multiplier,
        addLiquidityUrl: addLiquidityUrl,
        cakePrice: cakePrice,
        showActiveBooster: boosterState === useYieldBoosterState/* YieldBoosterState.ACTIVE */.M.ACTIVE
    })), 1), onPresentDeposit = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(WithdrawModal/* default */.Z, {
        showActiveBooster: boosterState === useYieldBoosterState/* YieldBoosterState.ACTIVE */.M.ACTIVE,
        max: stakedBalance,
        onConfirm: handleUnstake,
        tokenName: lpSymbol
    })), 1), onPresentWithdraw = ref3[0];
    var handleApprove = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var receipt;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchWithCatchTxError(function() {
                        return onApprove();
                    });
                case 2:
                    receipt = _ctx.sent;
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Contract Enabled"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash
                        }));
                        onDone();
                    }
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        onApprove,
        t,
        toastSuccess,
        fetchWithCatchTxError,
        onDone
    ]);
    if (!account) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledActionContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ActionTitles */.Ad, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        textTransform: "uppercase",
                        color: "textSubtle",
                        fontSize: "12px",
                        children: t("Start Farming")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ActionContent */.O6, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                        width: "100%"
                    })
                })
            ]
        });
    }
    if (isApproved) {
        if (stakedBalance.gt(0)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledActionContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ActionTitles */.Ad, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                textTransform: "uppercase",
                                color: "secondary",
                                fontSize: "12px",
                                pr: "4px",
                                children: lpSymbol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                textTransform: "uppercase",
                                color: "textSubtle",
                                fontSize: "12px",
                                children: t("Staked")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ActionContent */.O6, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StakedLP/* default */.Z, {
                                stakedBalance: stakedBalance,
                                lpSymbol: lpSymbol,
                                quoteTokenSymbol: quoteToken.symbol,
                                tokenSymbol: token.symbol,
                                lpTotalSupply: lpTotalSupply,
                                tokenAmountTotal: tokenAmountTotal,
                                quoteTokenAmountTotal: quoteTokenAmountTotal
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButtonWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        variant: "secondary",
                                        onClick: onPresentWithdraw,
                                        mr: "6px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {
                                            color: "primary",
                                            width: "14px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        variant: "secondary",
                                        onClick: onPresentDeposit,
                                        disabled: [
                                            "history",
                                            "archived"
                                        ].some(function(item) {
                                            return router.pathname.includes(item);
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                            color: "primary",
                                            width: "14px"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledActionContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ActionTitles */.Ad, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            bold: true,
                            textTransform: "uppercase",
                            color: "textSubtle",
                            fontSize: "12px",
                            pr: "4px",
                            children: t("Stake")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            bold: true,
                            textTransform: "uppercase",
                            color: "secondary",
                            fontSize: "12px",
                            children: lpSymbol
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ActionContent */.O6, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        width: "100%",
                        onClick: onPresentDeposit,
                        variant: "secondary",
                        disabled: [
                            "history",
                            "archived"
                        ].some(function(item) {
                            return router.pathname.includes(item);
                        }),
                        children: t("Stake LP")
                    })
                })
            ]
        });
    }
    if (!userDataReady) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledActionContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ActionTitles */.Ad, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        textTransform: "uppercase",
                        color: "textSubtle",
                        fontSize: "12px",
                        children: t("Start Farming")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ActionContent */.O6, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 180,
                        marginBottom: 28,
                        marginTop: 14
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledActionContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ActionTitles */.Ad, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    bold: true,
                    textTransform: "uppercase",
                    color: "textSubtle",
                    fontSize: "12px",
                    children: t("Enable Farm")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ActionContent */.O6, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    width: "100%",
                    disabled: pendingTx,
                    onClick: handleApprove,
                    variant: "secondary",
                    children: t("Enable")
                })
            })
        ]
    });
};
/* harmony default export */ var StakedAction = (Staked);


/***/ }),

/***/ 5563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ad": function() { return /* binding */ ActionTitles; },
/* harmony export */   "O6": function() { return /* binding */ ActionContent; },
/* harmony export */   "sX": function() { return /* binding */ ActionContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px;\n  border: 2px solid ",
        ";\n  border-radius: 16px;\n  flex-grow: 1;\n  flex-basis: 0;\n  margin-bottom: 16px;\n\n  ",
        " {\n    margin-left: 12px;\n    margin-right: 12px;\n    margin-bottom: 12px;\n    /* max-height: 130px; */\n  }\n\n  ",
        " {\n    margin-right: 0;\n    margin-bottom: 0;\n    /* max-height: 130px; */\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var ActionContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-376364f5-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xl;
});
var ActionTitles = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-376364f5-1"
})(_templateObject1());
var ActionContent = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-376364f5-2"
})(_templateObject2());


/***/ }),

/***/ 36508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69589);
/* harmony import */ var components_Balance__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18778);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var state_farms_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48674);
/* harmony import */ var utils_formatBalance__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59123);






var StakedLP = function(param) {
    var stakedBalance = param.stakedBalance, lpSymbol = param.lpSymbol, quoteTokenSymbol = param.quoteTokenSymbol, tokenSymbol = param.tokenSymbol, lpTotalSupply = param.lpTotalSupply, tokenAmountTotal = param.tokenAmountTotal, quoteTokenAmountTotal = param.quoteTokenAmountTotal;
    var lpPrice = (0,state_farms_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useLpTokenPrice */ .w5)(lpSymbol);
    var displayBalance = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return (0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_4__/* .formatLpBalance */ .O$)(stakedBalance);
    }, [
        stakedBalance
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        flexDirection: "column",
        alignItems: "flex-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                color: stakedBalance.eq(0) ? "textDisabled" : "text",
                children: displayBalance
            }),
            stakedBalance.gt(0) && lpPrice.gt(0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Balance__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        fontSize: "12px",
                        color: "textSubtle",
                        decimals: 2,
                        value: (0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_4__/* .getBalanceNumber */ .mW)(lpPrice.times(stakedBalance)),
                        unit: " USD",
                        prefix: "~"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        style: {
                            gap: "4px"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Balance__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                decimals: 2,
                                value: stakedBalance.div(lpTotalSupply).times(tokenAmountTotal).toNumber(),
                                unit: " ".concat(tokenSymbol)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Balance__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                decimals: 2,
                                value: stakedBalance.div(lpTotalSupply).times(quoteTokenAmountTotal).toNumber(),
                                unit: " ".concat(quoteTokenSymbol)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StakedLP);


/***/ }),

/***/ 6105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44431);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(bignumber_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85937);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27208);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98553);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63771);
/* harmony import */ var components_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92176);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52775);
/* harmony import */ var utils_formatBalance__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59123);









var WithdrawModal = function(param) {
    var onConfirm = param.onConfirm, onDismiss = param.onDismiss, max = param.max, _tokenName = param.tokenName, tokenName = _tokenName === void 0 ? "" : _tokenName, showActiveBooster = param.showActiveBooster;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), val = ref[0], setVal = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), pendingTx = ref1[0], setPendingTx = ref1[1];
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)().t;
    var fullBalance = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return (0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_6__/* .getFullDisplayBalance */ .NJ)(max);
    }, [
        max
    ]);
    var valNumber = new (bignumber_js__WEBPACK_IMPORTED_MODULE_2___default())(val);
    var fullBalanceNumber = new (bignumber_js__WEBPACK_IMPORTED_MODULE_2___default())(fullBalance);
    var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(e) {
        if (e.currentTarget.validity.valid) {
            setVal(e.currentTarget.value.replace(/,/g, "."));
        }
    }, [
        setVal
    ]);
    var handleSelectMax = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        setVal(fullBalance);
    }, [
        fullBalance,
        setVal
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        title: t("Unstake LP tokens"),
        onDismiss: onDismiss,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Modal__WEBPACK_IMPORTED_MODULE_4__/* .ModalInput */ .S, {
                onSelectMax: handleSelectMax,
                onChange: handleChange,
                value: val,
                max: fullBalance,
                symbol: tokenName,
                inputTitle: t("Unstake")
            }),
            showActiveBooster ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                variant: "warning",
                mt: "8px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* .MessageText */ .Y, {
                    children: t("The yield booster multiplier will be updated based on the latest staking conditions.")
                })
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Modal__WEBPACK_IMPORTED_MODULE_4__/* .ModalActions */ .n, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        variant: "secondary",
                        onClick: onDismiss,
                        width: "100%",
                        disabled: pendingTx,
                        children: t("Cancel")
                    }),
                    pendingTx ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        width: "100%",
                        isLoading: pendingTx,
                        endIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            spin: true,
                            color: "currentColor"
                        }),
                        children: t("Confirming")
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        width: "100%",
                        disabled: !valNumber.isFinite() || valNumber.eq(0) || valNumber.gt(fullBalanceNumber),
                        onClick: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        setPendingTx(true);
                                        _ctx.next = 3;
                                        return onConfirm(val);
                                    case 3:
                                        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                                        setPendingTx(false);
                                    case 5:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        })),
                        children: t("Confirm")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WithdrawModal);


/***/ }),

/***/ 62006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_BoostedAction; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var src = __webpack_require__(52775);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(63771);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/NextLink.tsx
var NextLink = __webpack_require__(12966);
// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/hooks/useYieldBoosterState.ts + 2 modules
var useYieldBoosterState = __webpack_require__(86598);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(36963);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(76431);
// EXTERNAL MODULE: ./src/hooks/useCallWithGasPrice.ts
var useCallWithGasPrice = __webpack_require__(85900);
;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/hooks/useBoosterFarmHandlers.ts






var useBoosterFarmHandlers = function(farmPid, onDone) {
    var farmBoosterContract = (0,useContract/* useBCakeFarmBoosterContract */.gh)();
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, isConfirming = ref.loading;
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var activate = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var receipt;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchWithCatchTxError(function() {
                        return callWithGasPrice(farmBoosterContract, "activate", [
                            farmPid
                        ]);
                    });
                case 2:
                    receipt = _ctx.sent;
                    if ((receipt === null || receipt === void 0 ? void 0 : receipt.status) && onDone) {
                        onDone();
                    }
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        farmPid,
        farmBoosterContract,
        callWithGasPrice,
        fetchWithCatchTxError,
        onDone
    ]);
    var deactivate = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var receipt;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchWithCatchTxError(function() {
                        return callWithGasPrice(farmBoosterContract, "deactive", [
                            farmPid
                        ]);
                    });
                case 2:
                    receipt = _ctx.sent;
                    if ((receipt === null || receipt === void 0 ? void 0 : receipt.status) && onDone) {
                        onDone();
                    }
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        farmPid,
        farmBoosterContract,
        callWithGasPrice,
        fetchWithCatchTxError,
        onDone
    ]);
    return {
        activate: activate,
        deactivate: deactivate,
        isConfirming: isConfirming
    };
};
/* harmony default export */ var hooks_useBoosterFarmHandlers = (useBoosterFarmHandlers);

// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/hooks/useBoostMultiplier.ts
var useBoostMultiplier = __webpack_require__(46579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(40735);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(34701);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(88896);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(98553);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(69589);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var TooltipText = __webpack_require__(94998);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Help.tsx
var Help = __webpack_require__(95160);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/components/ActionButton.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 4px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-33d0425a-0"
})(_templateObject());
var BoosterTooltip = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            t("Boost multiplier is calculated based on the staking conditions from both Farms and fixed-term CAKE syrup pool and will be automatically updated upon user actions."),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                href: "https://docs.pancakeswap.finance/products/yield-farming/bcake/faq#how-are-the-bcake-multipliers-calculated",
                external: true,
                children: t("Learn More")
            })
        ]
    });
};
var ActionButton = function(_param) {
    var title = _param.title, description = _param.description, button = _param.button, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "description",
        "button"
    ]);
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var btn = null;
    var ref = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(BoosterTooltip, {}), (0,_object_spread/* default */.Z)({
        placement: "top"
    }, isMobile && {
        hideTimeout: 1500
    })), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    if (button) {
        btn = button;
    } else if (!isEmpty_default()(props)) {
        btn = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                mr: "4px",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                                ref: targetRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                                    width: "20px",
                                    height: "20px"
                                })
                            }),
                            tooltipVisible && tooltip
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        fontSize: "12px",
                        children: description
                    })
                ]
            }),
            btn
        ]
    });
};
/* harmony default export */ var components_ActionButton = (ActionButton);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(19237);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 1 modules
var Toast = __webpack_require__(96036);
;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/components/CreateProxyButton.tsx












var MAX_GAS_LIMIT = 2500000;
var CreateProxyButton = function(_param) {
    var onDone = _param.onDone, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onDone"
    ]);
    var t = (0,src/* useTranslation */.$G)().t;
    var farmBoosterProxyFactoryContract = (0,useContract/* useBCakeFarmBoosterProxyFactoryContract */.lZ)();
    var ref = (0,react.useState)(false), isCreateProxyLoading = ref[0], setIsCreateProxyLoading = ref[1];
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var ref1 = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref1.fetchWithCatchTxError, loading = ref1.loading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "100%"
    }, props), {
        onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setIsCreateProxyLoading(true);
                        _ctx.next = 4;
                        return fetchWithCatchTxError(function() {
                            return farmBoosterProxyFactoryContract.createFarmBoosterProxy({
                                gasLimit: MAX_GAS_LIMIT
                            });
                        });
                    case 4:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess(t("Contract Enabled"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                txHash: receipt.transactionHash
                            }));
                        }
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                    case 11:
                        _ctx.prev = 11;
                        setIsCreateProxyLoading(false);
                        onDone === null || onDone === void 0 ? void 0 : onDone();
                        return _ctx.finish(11);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8,
                    11,
                    15
                ]
            ]);
        })),
        isLoading: isCreateProxyLoading || loading,
        endIcon: isCreateProxyLoading || loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
            spin: true,
            color: "currentColor"
        }) : undefined,
        children: isCreateProxyLoading || loading ? t("Confirming...") : t("Enable")
    }));
};
/* harmony default export */ var components_CreateProxyButton = (/*#__PURE__*/(0,react.memo)(CreateProxyButton));

// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/components/ProxyFarmContainer.tsx
var ProxyFarmContainer = __webpack_require__(28696);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(21812);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/state/index.ts + 31 modules
var state = __webpack_require__(2154);
// EXTERNAL MODULE: ./src/state/farms/index.ts + 10 modules
var farms = __webpack_require__(14425);
// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 1 modules
var hooks = __webpack_require__(48674);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useUnstakeFarms.ts
var useUnstakeFarms = __webpack_require__(7938);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(85937);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Logo.tsx
var Logo = __webpack_require__(67952);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Checkmark.tsx
var Checkmark = __webpack_require__(12851);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var wagmi_src = __webpack_require__(29315);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useBCakeProxyContractAddress.ts
var useBCakeProxyContractAddress = __webpack_require__(80922);
// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/hooks/useProxyStakedActions.ts + 1 modules
var useProxyStakedActions = __webpack_require__(46791);
;// CONCATENATED MODULE: ./src/views/Farms/components/BCakeMigrateModal.tsx




function BCakeMigrateModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  color: white;\n  text-align: center;\n  line-height: 20px;\n  padding: 2px;\n  box-sizing: border-box;\n  font-size: 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n"
    ]);
    BCakeMigrateModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: calc(100% + 10px);\n  left: 50%;\n  transform: translateX(-50%);\n  transition: 0.3s color ease-in-out;\n  will-change: color;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 20px;\n  width: 20px;\n  display: inline-block;\n  vertical-align: top;\n  &:not(:last-child) {\n    margin-right: calc((100% - 60px) / 2);\n    &::before {\n      position: absolute;\n      content: '';\n      width: calc(((100vw / 2) - 108px));\n      height: 2px;\n      top: 9px;\n      left: 30px;\n      transition: 0.3s background-color ease-in-out;\n      will-change: background-color;\n      background-color: ",
        ";\n    }\n    ",
        " {\n      &::before {\n        width: 104px;\n      }\n    }\n  }\n  ",
        " {\n    background: ",
        ";\n  }\n  ",
        " {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n  padding-top: 24px;\n  position: relative;\n  &::before {\n    content: '';\n    position: absolute;\n    height: 1px;\n    width: 100%;\n    top: 0px;\n    left: 0px;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 16px;\n  font-size: 12px;\n  color: ",
        ";\n  line-height: 120%;\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ",
        " {\n    width: 372px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}












var StepperCircle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6a6ce0f6-0"
})(BCakeMigrateModal_templateObject());
var StepperText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6a6ce0f6-1"
})(_templateObject1());
var StepperWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6a6ce0f6-2"
})(_templateObject2(), function(param) {
    var theme = param.theme, finished = param.finished;
    return finished ? theme.colors.textSubtle : theme.colors.disabled;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, StepperCircle, function(param) {
    var theme = param.theme, finished = param.finished;
    return finished ? theme.colors.textSubtle : theme.colors.disabled;
}, StepperText, function(param) {
    var theme = param.theme, active = param.active, finished = param.finished;
    return active ? theme.colors.primary : finished ? theme.colors.textSubtle : theme.colors.disabled;
});
var FooterBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6a6ce0f6-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var InfoBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6a6ce0f6-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var InfoText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6a6ce0f6-5"
})(_templateObject5());
var InfoIconBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6a6ce0f6-6"
})(_templateObject6());
var Steps;
(function(Steps) {
    Steps[Steps["UnStake"] = 0] = "UnStake";
    Steps[Steps["Enable"] = 1] = "Enable";
    Steps[Steps["Stake"] = 2] = "Stake";
})(Steps || (Steps = {}));
var _obj;
var migrationSteps = (_obj = {}, (0,_define_property/* default */.Z)(_obj, Steps.UnStake, "Unstake LP tokens from the farm"), (0,_define_property/* default */.Z)(_obj, Steps.Enable, "Enable staking with yield booster"), (0,_define_property/* default */.Z)(_obj, Steps.Stake, "Stake LP tokens back to the farm"), _obj);
var migrationStepsKeys = Object.keys(migrationSteps);
var BCakeMigrateModal = function(param) {
    var lpContract = param.lpContract, stakedBalance = param.stakedBalance, onDismiss = param.onDismiss, onUnStack = param.onUnStack, pid = param.pid;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var ref = (0,react.useState)(Steps.UnStake), activatedState = ref[0], setActivatedState = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(false), isApproved = ref2[0], setIsApproved = ref2[1];
    var t = (0,src/* useTranslation */.$G)().t;
    var fullBalance = (0,react.useMemo)(function() {
        return (0,formatBalance/* getFullDisplayBalance */.NJ)(stakedBalance);
    }, [
        stakedBalance
    ]);
    var proxyAddress = (0,useBCakeProxyContractAddress/* useBCakeProxyContractAddress */.A)(account).proxyAddress;
    var ref3 = (0,useProxyStakedActions/* default */.Z)(pid, lpContract), onApprove = ref3.onApprove, onDone = ref3.onDone, onStake = ref3.onStake;
    var bCakeProxy = (0,useContract/* useBCakeProxyContract */.DE)(proxyAddress);
    var ref4 = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref4.fetchWithCatchTxError, loading = ref4.loading;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var ref5 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        children: t("To enable farm yield boosters, you must follow the guide and migrate your current farming positions. However, for each farm, you will only need to migrate once.")
    }), {
        placement: "right"
    }), targetRef = ref5.targetRef, tooltip = ref5.tooltip, tooltipVisible = ref5.tooltipVisible;
    (0,react.useEffect)(function() {
        if (!bCakeProxy) return;
        bCakeProxy.lpApproved(lpContract.address).then(function(enabled) {
            setIsApproved(enabled);
        });
    }, [
        lpContract,
        bCakeProxy
    ]);
    var onStepChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var receipt, receipt1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(activatedState === Steps.UnStake)) {
                            _ctx.next = 4;
                            break;
                        }
                        {
                            setIsLoading(true);
                            onUnStack(fullBalance, function() {
                                if (isApproved) setActivatedState(Steps.Stake);
                                else setActivatedState(Steps.Enable);
                                setIsLoading(false);
                            });
                        }
                        _ctx.next = 25;
                        break;
                    case 4:
                        if (!(activatedState === Steps.Enable)) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.next = 7;
                        return fetchWithCatchTxError(onApprove);
                    case 7:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess(t("Contract Enabled"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                txHash: receipt.transactionHash
                            }));
                            setActivatedState(Steps.Stake);
                            onDone();
                        }
                        _ctx.next = 25;
                        break;
                    case 11:
                        setIsLoading(true);
                        _ctx.prev = 12;
                        _ctx.next = 15;
                        return fetchWithCatchTxError(function() {
                            return onStake(fullBalance);
                        });
                    case 15:
                        receipt1 = _ctx.sent;
                        if (receipt1 === null || receipt1 === void 0 ? void 0 : receipt1.status) {
                            toastSuccess("".concat(t("Staked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                txHash: receipt1.transactionHash,
                                children: t("Your funds have been staked in the farm")
                            }));
                            onDone();
                            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                        }
                        _ctx.next = 22;
                        break;
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t0 = _ctx["catch"](12);
                        console.error(_ctx.t0);
                    case 22:
                        _ctx.prev = 22;
                        setIsLoading(false);
                        return _ctx.finish(22);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    12,
                    19,
                    22,
                    25
                ]
            ]);
        }));
        return function onStepChange() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        title: t("Migrate your stakings"),
        width: "420px",
        onDismiss: onDismiss,
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoBox, {
                ref: targetRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoText, {
                        children: t("You will need to migrate your stakings before activating yield booster for a farm")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIconBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                pb: 20,
                pl: 38,
                pr: 30,
                children: migrationStepsKeys.map(function(step, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepperWrapper, {
                        active: step === activatedState.toString(),
                        finished: parseInt(step) < parseInt(activatedState.toString()),
                        children: [
                            step === activatedState.toString() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                                width: 22
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperCircle, {
                                children: parseInt(step) < parseInt(activatedState.toString()) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkmark/* default */.Z, {
                                    color: "white",
                                    width: 16
                                }) : index + 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperText, {
                                children: Steps[step]
                            })
                        ]
                    }, step);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterBox, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        mb: "16px",
                        textAlign: "center",
                        children: [
                            activatedState + 1,
                            ". ",
                            t(migrationSteps[activatedState])
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: onStepChange,
                        isLoading: isLoading || loading,
                        width: "100%",
                        endIcon: isLoading || loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                            spin: true,
                            color: "currentColor"
                        }) : undefined,
                        children: isLoading || loading ? t("Confirming...") : t(Steps[activatedState])
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/components/MigrateActionButton.tsx















var MigrateActionButton = function(param) {
    var pid = param.pid;
    var t = (0,src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var fetchWithCatchTxError = (0,useCatchTxError/* default */.Z)().fetchWithCatchTxError;
    var ref = (0,useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var onUnstake = (0,useUnstakeFarms/* default */.Z)(pid).onUnstake;
    var stakedBalance = (0,hooks/* useFarmUser */.Dx)(pid).stakedBalance;
    var lpAddress = (0,hooks/* useFarmFromPid */.f6)(pid).lpAddress;
    var lpContract = (0,useContract/* useERC20 */.X_)(lpAddress);
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var handleUnstakeWithCallback = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(amount, callback) {
            var receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchWithCatchTxError(function() {
                            return onUnstake(amount);
                        });
                    case 2:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess("".concat(t("Unstaked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                txHash: receipt.transactionHash,
                                children: t("Your earnings have also been harvested to your wallet")
                            }));
                            callback();
                            dispatch((0,farms/* fetchFarmUserDataAsync */.IV)({
                                account: account,
                                pids: [
                                    pid
                                ],
                                chainId: chainId
                            }));
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleUnstakeWithCallback(amount, callback) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(BCakeMigrateModal, {
        pid: pid,
        stakedBalance: stakedBalance,
        lpContract: lpContract,
        onUnStack: handleUnstakeWithCallback
    })), 1), onPresentMigrate = ref1[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        onClick: onPresentMigrate,
        children: t("Migrate")
    });
};
/* harmony default export */ var components_MigrateActionButton = (MigrateActionButton);

;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/components/BoostedAction.tsx













var BoostedAction = function(param) {
    var farmPid = param.farmPid, title = param.title, desc = param.desc;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,react.useContext)(ProxyFarmContainer/* YieldBoosterStateContext */._), boosterState = ref.boosterState, refreshActivePool = ref.refreshActivePool, refreshProxyAddress = ref.refreshProxyAddress, proxyAddress = ref.proxyAddress;
    var _ref = hooks_useBoosterFarmHandlers(farmPid, refreshActivePool), isConfirming = _ref.isConfirming, handlers = (0,_object_without_properties/* default */.Z)(_ref, [
        "isConfirming"
    ]);
    var boostMultiplier = (0,useBoostMultiplier/* default */.Z)({
        pid: farmPid,
        boosterState: boosterState,
        proxyAddress: proxyAddress
    });
    var boostMultiplierDisplay = boostMultiplier.toLocaleString(undefined, {
        maximumFractionDigits: 3
    });
    var renderBtn = (0,react.useCallback)(function() {
        switch(boosterState){
            case useYieldBoosterState/* YieldBoosterState.UNCONNECTED */.M.UNCONNECTED:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionButton, {
                    title: "".concat(t("Up to"), " ").concat(boostMultiplierDisplay, "x"),
                    description: t("Connect wallet to activate yield booster")
                });
            case useYieldBoosterState/* YieldBoosterState.NO_LOCKED */.M.NO_LOCKED:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionButton, {
                    title: "".concat(t("Up to"), " ").concat(boostMultiplierDisplay, "x"),
                    description: t("Lock CAKE to activate yield booster"),
                    style: {
                        whiteSpace: "nowrap"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                        to: "/pools",
                        children: t("Go to Pool")
                    })
                });
            case useYieldBoosterState/* YieldBoosterState.LOCKED_END */.M.LOCKED_END:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionButton, {
                    title: "".concat(t("Up to"), " ").concat(boostMultiplierDisplay, "x"),
                    description: t("Lock CAKE is ended. Re-lock CAKE to activate yield booster"),
                    style: {
                        whiteSpace: "nowrap"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                        to: "/pools",
                        children: t("Go to Pool")
                    })
                });
            case useYieldBoosterState/* YieldBoosterState.NO_PROXY_CREATED */.M.NO_PROXY_CREATED:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionButton, {
                    title: "".concat(boostMultiplierDisplay, "x"),
                    description: t("One-time setup is required for activating farm yield boosters"),
                    button: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CreateProxyButton, {
                        onDone: refreshProxyAddress,
                        width: "auto"
                    })
                });
            case useYieldBoosterState/* YieldBoosterState.NO_MIGRATE */.M.NO_MIGRATE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionButton, {
                    title: "".concat(boostMultiplierDisplay, "x"),
                    description: t("Migration required to activate boost"),
                    button: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MigrateActionButton, {
                        pid: farmPid
                    })
                });
            case useYieldBoosterState/* YieldBoosterState.NO_LP */.M.NO_LP:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionButton, {
                    title: "".concat(boostMultiplierDisplay, "x"),
                    description: t("Stake LP tokens to start boosting"),
                    disabled: true,
                    children: t("Boost")
                });
            case useYieldBoosterState/* YieldBoosterState.DEACTIVE */.M.DEACTIVE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionButton, {
                    disabled: isConfirming,
                    onClick: handlers.activate,
                    title: "".concat(boostMultiplierDisplay, "x"),
                    isLoading: isConfirming,
                    description: t("Yield booster available"),
                    endIcon: isConfirming && /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                        spin: true,
                        color: "currentColor"
                    }),
                    children: t("Boost")
                });
            case useYieldBoosterState/* YieldBoosterState.ACTIVE */.M.ACTIVE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionButton, {
                    disabled: isConfirming,
                    onClick: handlers.deactivate,
                    title: "".concat(boostMultiplierDisplay, "x"),
                    isLoading: isConfirming,
                    description: t("Active"),
                    endIcon: isConfirming && /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                        spin: true,
                        color: "currentColor"
                    }),
                    children: t("Unset")
                });
            case useYieldBoosterState/* YieldBoosterState.MAX */.M.MAX:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActionButton, {
                    title: "".concat(boostMultiplierDisplay, "x"),
                    description: t("Unset other boosters to activate"),
                    disabled: true,
                    children: t("Boost")
                });
            default:
                return null;
        }
    }, [
        boosterState,
        t,
        handlers.activate,
        handlers.deactivate,
        isConfirming,
        farmPid,
        refreshProxyAddress,
        boostMultiplierDisplay, 
    ]);
    var status = null;
    if ([
        useYieldBoosterState/* YieldBoosterState.NO_MIGRATE */.M.NO_MIGRATE,
        useYieldBoosterState/* YieldBoosterState.DEACTIVE */.M.DEACTIVE
    ].includes(boosterState)) {
        status = t("Ready");
    } else if (boosterState === useYieldBoosterState/* YieldBoosterState.ACTIVE */.M.ACTIVE) {
        status = t("Active");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            title && title(status),
            desc && desc(renderBtn())
        ]
    });
};
/* harmony default export */ var components_BoostedAction = (BoostedAction);


/***/ }),

/***/ 52914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52775);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62077);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68479);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14841);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_toNumber__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var utils_formatBalance__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59123);
/* harmony import */ var _pancakeswap_utils_isUndefinedOrNull__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95923);
/* harmony import */ var _hooks_useBoostMultiplier__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46579);
/* harmony import */ var _hooks_useYieldBoosterState__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86598);
/* harmony import */ var _ProxyFarmContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28696);













function BoostedApr(props) {
    var lpRewardsApr = props.lpRewardsApr, apr = props.apr, pid = props.pid, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(props, [
        "lpRewardsApr",
        "apr",
        "pid"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_ProxyFarmContainer__WEBPACK_IMPORTED_MODULE_7__/* .YieldBoosterStateContext */ ._), boosterState = ref.boosterState, proxyAddress = ref.proxyAddress;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    var multiplier = (0,_hooks_useBoostMultiplier__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        pid: pid,
        boosterState: boosterState,
        proxyAddress: proxyAddress
    });
    var boostedApr = !(0,_pancakeswap_utils_isUndefinedOrNull__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(multiplier) && !(0,_pancakeswap_utils_isUndefinedOrNull__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(apr) && (0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_4__/* .formatNumber */ .uf)(lodash_toNumber__WEBPACK_IMPORTED_MODULE_2___default()(apr) * Number(multiplier) + (!(0,_pancakeswap_utils_isUndefinedOrNull__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(lpRewardsApr) ? lodash_toNumber__WEBPACK_IMPORTED_MODULE_2___default()(lpRewardsApr) : 0)) || "0";
    var msg = boosterState === _hooks_useYieldBoosterState__WEBPACK_IMPORTED_MODULE_6__/* .YieldBoosterState.ACTIVE */ .M.ACTIVE ? "".concat(boostedApr, "%") : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                bold: true,
                color: "success"
            }, rest), {
                fontSize: 14,
                display: "inline-block",
                mr: "3px",
                children: t("Up to")
            })),
            "".concat(boostedApr, "%")
        ]
    });
    if (boostedApr === "0") {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                m: "4px",
                color: "success"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                bold: true,
                color: "success"
            }, rest), {
                fontSize: 16,
                children: msg
            }))
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_3__.memo)(BoostedApr));


/***/ }),

/***/ 39085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22769);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68479);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52775);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);






var BoostedTag = function(props) {
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        variant: "success",
        style: {
            background: "none"
        },
        outline: true,
        startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            width: "18px",
            color: "success",
            mr: "4px"
        })
    }, props), {
        children: t("Boosted")
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(BoostedTag));


/***/ }),

/***/ 28696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ YieldBoosterStateContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50308);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useYieldBoosterState__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86598);






var YieldBoosterStateContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    boosterState: _hooks_useYieldBoosterState__WEBPACK_IMPORTED_MODULE_3__/* .YieldBoosterState.UNCONNECTED */ .M.UNCONNECTED,
    refreshActivePool: (lodash_noop__WEBPACK_IMPORTED_MODULE_2___default()),
    proxyFarm: {},
    shouldUseProxyFarm: false,
    refreshProxyAddress: (lodash_noop__WEBPACK_IMPORTED_MODULE_2___default()),
    proxyAddress: ""
});
var ProxyFarmContainer = function(param) {
    var children = param.children, farm = param.farm;
    var ref = (0,_hooks_useYieldBoosterState__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        farmPid: farm.pid
    }), boosterState = ref.state, refreshActivePool = ref.refreshActivePool, shouldUseProxyFarm = ref.shouldUseProxyFarm, refreshProxyAddress = ref.refreshProxyAddress, proxyAddress = ref.proxyAddress;
    var proxyFarm = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, farm), {
            userData: farm.userData.proxy
        });
    }, [
        farm
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(YieldBoosterStateContext.Provider, {
        value: {
            proxyAddress: proxyAddress,
            boosterState: boosterState,
            refreshActivePool: refreshActivePool,
            refreshProxyAddress: refreshProxyAddress,
            proxyFarm: proxyFarm,
            shouldUseProxyFarm: shouldUseProxyFarm
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(ProxyFarmContainer));


/***/ }),

/***/ 46579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBoostMultiplier; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10253);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97477);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36963);
/* harmony import */ var config_abi_farmBooster_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74551);
/* harmony import */ var config_abi_masterchef_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84951);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20335);
/* harmony import */ var utils_multicall__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9796);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8100);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14841);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_toNumber__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _useYieldBoosterState__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86598);













var PRECISION_FACTOR = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_10__/* .FixedNumber.from */ .xs.from("1000000000000") // 1e12
;
function getPublicMultiplier(_) {
    return _getPublicMultiplier.apply(this, arguments);
}
function _getPublicMultiplier() {
    _getPublicMultiplier = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var farmBoosterContract, calls, data, _data, ref, cA, ref1, CA_PRECISION, ref2, BOOST_PRECISION, MAX_BOOST_PRECISION, boostPercent;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    farmBoosterContract = param.farmBoosterContract;
                    calls = [
                        {
                            address: farmBoosterContract.address,
                            name: "cA"
                        },
                        {
                            address: farmBoosterContract.address,
                            name: "CA_PRECISION"
                        },
                        {
                            address: farmBoosterContract.address,
                            name: "BOOST_PRECISION"
                        }, 
                    ];
                    _ctx.next = 4;
                    return (0,utils_multicall__WEBPACK_IMPORTED_MODULE_5__/* .multicallv2 */ .v)({
                        abi: config_abi_farmBooster_json__WEBPACK_IMPORTED_MODULE_3__,
                        calls: calls
                    });
                case 4:
                    data = _ctx.sent;
                    if (data) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", 0);
                case 7:
                    _data = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(data, 3), ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_data[0], 1), cA = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_data[1], 1), CA_PRECISION = ref1[0], ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_data[2], 1), BOOST_PRECISION = ref2[0];
                    MAX_BOOST_PRECISION = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_10__/* .FixedNumber.from */ .xs.from(CA_PRECISION).divUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_10__/* .FixedNumber.from */ .xs.from(cA)).mulUnsafe(PRECISION_FACTOR).subUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_10__/* .FixedNumber.from */ .xs.from(BOOST_PRECISION));
                    boostPercent = PRECISION_FACTOR.addUnsafe(MAX_BOOST_PRECISION).divUnsafe(PRECISION_FACTOR);
                    return _ctx.abrupt("return", lodash_toNumber__WEBPACK_IMPORTED_MODULE_8___default()(boostPercent.round(3).toString()));
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getPublicMultiplier.apply(this, arguments);
}
function getUserMultiplier(_) {
    return _getUserMultiplier.apply(this, arguments);
}
function _getUserMultiplier() {
    _getUserMultiplier = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var farmBoosterContract, account, pid, calls, data, _data, ref, multiplier, ref1, BOOST_PRECISION;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    farmBoosterContract = param.farmBoosterContract, account = param.account, pid = param.pid;
                    calls = [
                        {
                            address: farmBoosterContract.address,
                            name: "getUserMultiplier",
                            params: [
                                account,
                                pid
                            ]
                        },
                        {
                            address: farmBoosterContract.address,
                            name: "BOOST_PRECISION"
                        }, 
                    ];
                    _ctx.next = 4;
                    return (0,utils_multicall__WEBPACK_IMPORTED_MODULE_5__/* .multicallv2 */ .v)({
                        abi: config_abi_farmBooster_json__WEBPACK_IMPORTED_MODULE_3__,
                        calls: calls
                    });
                case 4:
                    data = _ctx.sent;
                    if (data) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", 0);
                case 7:
                    _data = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(data, 2), ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_data[0], 1), multiplier = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_data[1], 1), BOOST_PRECISION = ref1[0];
                    return _ctx.abrupt("return", lodash_toNumber__WEBPACK_IMPORTED_MODULE_8___default()(PRECISION_FACTOR.addUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_10__/* .FixedNumber.from */ .xs.from(multiplier)).subUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_10__/* .FixedNumber.from */ .xs.from(BOOST_PRECISION)).divUnsafe(PRECISION_FACTOR).round(3).toString()));
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getUserMultiplier.apply(this, arguments);
}
function getMultiplierFromMC(_) {
    return _getMultiplierFromMC.apply(this, arguments);
}
function _getMultiplierFromMC() {
    _getMultiplierFromMC = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var pid, proxyAddress, masterChefContract, calls, data, _data, ref, boostMultiplier;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    pid = param.pid, proxyAddress = param.proxyAddress, masterChefContract = param.masterChefContract;
                    calls = [
                        {
                            address: masterChefContract.address,
                            name: "getBoostMultiplier",
                            params: [
                                proxyAddress,
                                pid
                            ]
                        }, 
                    ];
                    _ctx.next = 4;
                    return (0,utils_multicall__WEBPACK_IMPORTED_MODULE_5__/* .multicallv2 */ .v)({
                        abi: config_abi_masterchef_json__WEBPACK_IMPORTED_MODULE_4__,
                        calls: calls
                    });
                case 4:
                    data = _ctx.sent;
                    if (data === null || data === void 0 ? void 0 : data.length) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", 0);
                case 7:
                    _data = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(data, 1), ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_data[0], 1), boostMultiplier = ref[0];
                    return _ctx.abrupt("return", lodash_toNumber__WEBPACK_IMPORTED_MODULE_8___default()(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_10__/* .FixedNumber.from */ .xs.from(boostMultiplier).divUnsafe(PRECISION_FACTOR).round(3).toString()));
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getMultiplierFromMC.apply(this, arguments);
}
function useBoostMultiplier(param) {
    var pid = param.pid, boosterState = param.boosterState, proxyAddress = param.proxyAddress;
    var farmBoosterContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_2__/* .useBCakeFarmBoosterContract */ .gh)();
    var masterChefContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_2__/* .useMasterchef */ .y8)();
    var account = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().account;
    var shouldGetFromSC = [
        _useYieldBoosterState__WEBPACK_IMPORTED_MODULE_9__/* .YieldBoosterState.DEACTIVE */ .M.DEACTIVE,
        _useYieldBoosterState__WEBPACK_IMPORTED_MODULE_9__/* .YieldBoosterState.ACTIVE */ .M.ACTIVE,
        _useYieldBoosterState__WEBPACK_IMPORTED_MODULE_9__/* .YieldBoosterState.MAX */ .M.MAX
    ].includes(boosterState);
    var should1X = [
        _useYieldBoosterState__WEBPACK_IMPORTED_MODULE_9__/* .YieldBoosterState.LOCKED_END */ .M.LOCKED_END
    ].includes(boosterState);
    var getMultiplier = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!shouldGetFromSC) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", getMultiplierFromMC({
                        pid: pid,
                        masterChefContract: masterChefContract,
                        proxyAddress: proxyAddress
                    }));
                case 2:
                    return _ctx.abrupt("return", should1X ? getUserMultiplier({
                        farmBoosterContract: farmBoosterContract,
                        pid: pid,
                        account: account
                    }) : getPublicMultiplier({
                        farmBoosterContract: farmBoosterContract
                    }));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        farmBoosterContract,
        masterChefContract,
        should1X,
        shouldGetFromSC,
        pid,
        account,
        proxyAddress
    ]);
    var cacheName = shouldGetFromSC ? "proxy".concat(pid) : should1X ? "user".concat(pid) : "public".concat(pid);
    var data = (0,swr__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)([
        "boostMultiplier",
        cacheName
    ], getMultiplier).data;
    return data || 0;
};


/***/ }),

/***/ 46791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useProxyStakedActions; }
});

// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var src = __webpack_require__(29315);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(36963);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/state/index.ts + 31 modules
var state = __webpack_require__(2154);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var hooks = __webpack_require__(921);
// EXTERNAL MODULE: ./src/utils/calls/farms.ts
var farms = __webpack_require__(70372);
// EXTERNAL MODULE: ./src/state/farms/index.ts + 10 modules
var state_farms = __webpack_require__(14425);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useBCakeProxyContractAddress.ts
var useBCakeProxyContractAddress = __webpack_require__(80922);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useApproveFarm.ts
var useApproveFarm = __webpack_require__(30685);
// EXTERNAL MODULE: ./src/hooks/useSWRContract.ts
var useSWRContract = __webpack_require__(22408);
// EXTERNAL MODULE: ./src/utils/contractHelpers.ts + 29 modules
var contractHelpers = __webpack_require__(18380);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/hooks/useProxyCAKEBalance.ts






var useProxyCAKEBalance = function() {
    var account = (0,src/* useWeb3React */.Ge)().account;
    var proxyAddress = (0,useBCakeProxyContractAddress/* useBCakeProxyContractAddress */.A)(account).proxyAddress;
    var cakeContract = (0,contractHelpers/* getCakeContract */.XT)();
    var ref = (0,useSWRContract/* useSWRContract */.Av)([
        cakeContract,
        "balanceOf",
        [
            proxyAddress
        ]
    ]), data = ref.data, mutate = ref.mutate;
    return {
        refreshProxyCakeBalance: mutate,
        proxyCakeBalance: data ? (0,formatBalance/* getBalanceNumber */.mW)(new (bignumber_default())(data.toString())) : 0
    };
};
/* harmony default export */ var hooks_useProxyCAKEBalance = (useProxyCAKEBalance);

;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/hooks/useProxyStakedActions.ts











function useProxyStakedActions(pid, lpContract) {
    var account = (0,src/* useWeb3React */.Ge)().account;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var proxyAddress = (0,useBCakeProxyContractAddress/* useBCakeProxyContractAddress */.A)(account).proxyAddress;
    var bCakeProxy = (0,useContract/* useBCakeProxyContract */.DE)(proxyAddress);
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var gasPrice = (0,hooks/* useGasPrice */.Fh)();
    var ref = hooks_useProxyCAKEBalance(), proxyCakeBalance = ref.proxyCakeBalance, refreshProxyCakeBalance = ref.refreshProxyCakeBalance;
    var onDone = (0,react.useCallback)(function() {
        refreshProxyCakeBalance();
        dispatch((0,state_farms/* fetchFarmUserDataAsync */.IV)({
            account: account,
            pids: [
                pid
            ],
            chainId: chainId,
            proxyAddress: proxyAddress
        }));
    }, [
        account,
        proxyAddress,
        chainId,
        pid,
        dispatch,
        refreshProxyCakeBalance
    ]);
    var onApprove = (0,useApproveFarm/* useApproveBoostProxyFarm */.J)(lpContract, proxyAddress).onApprove;
    var onStake = (0,react.useCallback)(function(value) {
        return (0,farms/* stakeFarm */.AQ)(bCakeProxy, pid, value, gasPrice);
    }, [
        bCakeProxy,
        pid,
        gasPrice
    ]);
    var onUnstake = (0,react.useCallback)(function(value) {
        return (0,farms/* unstakeFarm */.dU)(bCakeProxy, pid, value, gasPrice);
    }, [
        bCakeProxy,
        pid,
        gasPrice
    ]);
    var onReward = (0,react.useCallback)(function() {
        return (0,farms/* harvestFarm */.sA)(bCakeProxy, pid, gasPrice);
    }, [
        bCakeProxy,
        pid,
        gasPrice
    ]);
    return {
        onStake: onStake,
        onUnstake: onUnstake,
        onReward: onReward,
        onApprove: onApprove,
        onDone: onDone,
        proxyCakeBalance: proxyCakeBalance
    };
};


/***/ }),

/***/ 86598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ YieldBoosterState; },
  "Z": function() { return /* binding */ useYieldBoosterState; }
});

// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 1 modules
var hooks = __webpack_require__(48674);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(36963);
// EXTERNAL MODULE: ./src/hooks/useSWRContract.ts
var useSWRContract = __webpack_require__(22408);
// EXTERNAL MODULE: ./src/config/abi/farmBooster.json
var farmBooster = __webpack_require__(74551);
// EXTERNAL MODULE: ./packages/utils/isUndefinedOrNull.ts
var isUndefinedOrNull = __webpack_require__(95923);
// EXTERNAL MODULE: ./src/config/constants/types.ts
var types = __webpack_require__(75759);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/swr/immutable/dist/index.mjs
var immutable_dist = __webpack_require__(49770);
;// CONCATENATED MODULE: ./src/views/Farms/hooks/useUserBoosterStatus.ts




var useUserBoosterStatus = function(account) {
    var farmBoosterContract = (0,useContract/* useBCakeFarmBoosterContract */.gh)();
    var ref = (0,immutable_dist/* default */.Z)("maxBoostFarm", function() {
        return farmBoosterContract.MAX_BOOST_POOL();
    }), MAX_BOOST_POOL = ref.data, maxBoostStatus = ref.status;
    var ref1 = (0,dist/* default */.ZP)(account && [
        "activatedBoostFarm",
        [
            account
        ]
    ], function() {
        return farmBoosterContract.activedPools(account);
    }), activatedPools = ref1.data, status = ref1.status, mutate = ref1.mutate;
    var ref2, ref3, ref4, ref5;
    return {
        maxBoostCounts: (ref2 = MAX_BOOST_POOL === null || MAX_BOOST_POOL === void 0 ? void 0 : MAX_BOOST_POOL.toNumber()) !== null && ref2 !== void 0 ? ref2 : 0,
        activatedPoolsCounts: (ref3 = activatedPools === null || activatedPools === void 0 ? void 0 : activatedPools.length) !== null && ref3 !== void 0 ? ref3 : 0,
        remainingCounts: ((ref4 = MAX_BOOST_POOL === null || MAX_BOOST_POOL === void 0 ? void 0 : MAX_BOOST_POOL.toNumber()) !== null && ref4 !== void 0 ? ref4 : 0) - ((ref5 = activatedPools === null || activatedPools === void 0 ? void 0 : activatedPools.length) !== null && ref5 !== void 0 ? ref5 : 0),
        isLoading: maxBoostStatus !== types/* FetchStatus.Fetched */.iF.Fetched || status !== types/* FetchStatus.Fetched */.iF.Fetched,
        refreshActivePools: mutate
    };
};

// EXTERNAL MODULE: ./src/views/Farms/hooks/useBCakeProxyContractAddress.ts
var useBCakeProxyContractAddress = __webpack_require__(80922);
// EXTERNAL MODULE: ./src/state/pools/hooks.ts + 1 modules
var pools_hooks = __webpack_require__(83251);
// EXTERNAL MODULE: ./src/state/types.ts
var state_types = __webpack_require__(96470);
;// CONCATENATED MODULE: ./src/views/Farms/hooks/useUserLockedCakeStatus.ts


var useUserLockedCakeStatus = function() {
    var ref, ref1, ref2;
    var vaultPool = (0,pools_hooks/* useVaultPoolByKey */.eB)(state_types/* VaultKey.CakeVault */.om.CakeVault);
    return {
        isLoading: vaultPool === null || vaultPool === void 0 ? void 0 : (ref = vaultPool.userData) === null || ref === void 0 ? void 0 : ref.isLoading,
        locked: Boolean(vaultPool === null || vaultPool === void 0 ? void 0 : (ref1 = vaultPool.userData) === null || ref1 === void 0 ? void 0 : ref1.locked),
        lockedEnd: vaultPool === null || vaultPool === void 0 ? void 0 : (ref2 = vaultPool.userData) === null || ref2 === void 0 ? void 0 : ref2.lockEndTime
    };
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/hooks/useYieldBoosterState.ts










var YieldBoosterState;
(function(YieldBoosterState) {
    YieldBoosterState[YieldBoosterState["UNCONNECTED"] = 0] = "UNCONNECTED";
    YieldBoosterState[YieldBoosterState["NO_LOCKED"] = 1] = "NO_LOCKED";
    YieldBoosterState[YieldBoosterState["LOCKED_END"] = 2] = "LOCKED_END";
    YieldBoosterState[YieldBoosterState["NO_PROXY_CREATED"] = 3] = "NO_PROXY_CREATED";
    YieldBoosterState[YieldBoosterState["NO_MIGRATE"] = 4] = "NO_MIGRATE";
    YieldBoosterState[YieldBoosterState["NO_LP"] = 5] = "NO_LP";
    YieldBoosterState[YieldBoosterState["DEACTIVE"] = 6] = "DEACTIVE";
    YieldBoosterState[YieldBoosterState["ACTIVE"] = 7] = "ACTIVE";
    YieldBoosterState[YieldBoosterState["MAX"] = 8] = "MAX";
})(YieldBoosterState || (YieldBoosterState = {}));
function useIsPoolActive(pid) {
    var farmBoosterContract = (0,useContract/* useBCakeFarmBoosterContract */.gh)();
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var ref = (0,useSWRContract/* useSWRMulticall */.d5)(farmBooster, [
        {
            address: farmBoosterContract.address,
            name: "isBoostedPool",
            params: [
                account,
                pid
            ]
        }
    ], {
        isPaused: function() {
            return !account;
        }
    }), data = ref.data, mutate = ref.mutate;
    return {
        isActivePool: Array.isArray(data) ? data[0][0] : false,
        refreshIsPoolActive: mutate
    };
}
function useYieldBoosterState(yieldBoosterStateArgs) {
    var farmPid = yieldBoosterStateArgs.farmPid;
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var ref = useUserBoosterStatus(account), remainingCounts = ref.remainingCounts, refreshActivePools = ref.refreshActivePools;
    var ref1 = useUserLockedCakeStatus(), locked = ref1.locked, lockedEnd = ref1.lockedEnd;
    var ref2 = (0,hooks/* useFarmUser */.Dx)(farmPid), stakedBalance = ref2.stakedBalance, proxy = ref2.proxy;
    var ref3 = useIsPoolActive(farmPid), isActivePool = ref3.isActivePool, refreshIsPoolActive = ref3.refreshIsPoolActive;
    var ref4 = (0,useBCakeProxyContractAddress/* useBCakeProxyContractAddress */.A)(account), proxyCreated = ref4.proxyCreated, refreshProxyAddress = ref4.refreshProxyAddress, proxyAddress = ref4.proxyAddress;
    var refreshActivePool = (0,react.useCallback)(function() {
        refreshActivePools();
        refreshIsPoolActive();
    }, [
        refreshActivePools,
        refreshIsPoolActive
    ]);
    var state = null;
    if (!account || (0,isUndefinedOrNull/* default */.Z)(locked)) {
        state = YieldBoosterState.UNCONNECTED;
    } else if (!locked) {
        // NOTE: depend on useCakeVaultUserData in Farm Component to check state
        state = YieldBoosterState.NO_LOCKED;
    } else if (!proxyCreated) {
        state = YieldBoosterState.NO_PROXY_CREATED;
    } else if (stakedBalance.gt(0)) {
        state = YieldBoosterState.NO_MIGRATE;
    } else if (lockedEnd === "0" || new Date() > new Date(parseInt(lockedEnd) * 1000)) {
        // NOTE: duplicate logic in BCakeBoosterCard
        state = YieldBoosterState.LOCKED_END;
    } else if (!(proxy === null || proxy === void 0 ? void 0 : proxy.stakedBalance.gt(0))) {
        state = YieldBoosterState.NO_LP;
    } else if (!isActivePool && remainingCounts === 0) {
        state = YieldBoosterState.MAX;
    } else if (isActivePool) {
        state = YieldBoosterState.ACTIVE;
    } else {
        state = YieldBoosterState.DEACTIVE;
    }
    return {
        state: state,
        shouldUseProxyFarm: [
            YieldBoosterState.DEACTIVE,
            YieldBoosterState.ACTIVE,
            YieldBoosterState.MAX,
            YieldBoosterState.NO_LP,
            YieldBoosterState.LOCKED_END, 
        ].includes(state),
        refreshActivePool: refreshActivePool,
        refreshProxyAddress: refreshProxyAddress,
        proxyAddress: proxyAddress
    };
};


/***/ }),

/***/ 17170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ getDisplayApr; }
/* harmony export */ });
var getDisplayApr = function(cakeRewardsApr, lpRewardsApr) {
    if (cakeRewardsApr && lpRewardsApr) {
        return (cakeRewardsApr + lpRewardsApr).toLocaleString("en-US", {
            maximumFractionDigits: 2
        });
    }
    if (cakeRewardsApr) {
        return cakeRewardsApr.toLocaleString("en-US", {
            maximumFractionDigits: 2
        });
    }
    return null;
};


/***/ }),

/***/ 30685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useApproveBoostProxyFarm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ethersproject_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21046);
/* harmony import */ var utils_addressHelpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8414);
/* harmony import */ var hooks_useCallWithGasPrice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85900);






var useApproveFarm = function(lpContract, chainId) {
    var masterChefAddress = (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_2__/* .getMasterChefAddress */ .Oc)(chainId);
    var callWithGasPrice = (0,hooks_useCallWithGasPrice__WEBPACK_IMPORTED_MODULE_3__/* .useCallWithGasPrice */ .d)().callWithGasPrice;
    var handleApprove = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", callWithGasPrice(lpContract, "approve", [
                        masterChefAddress,
                        _ethersproject_constants__WEBPACK_IMPORTED_MODULE_5__/* .MaxUint256 */ .Bz
                    ]));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        lpContract,
        masterChefAddress,
        callWithGasPrice
    ]);
    return {
        onApprove: handleApprove
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useApproveFarm);
var useApproveBoostProxyFarm = function(lpContract, proxyAddress) {
    var callWithGasPrice = (0,hooks_useCallWithGasPrice__WEBPACK_IMPORTED_MODULE_3__/* .useCallWithGasPrice */ .d)().callWithGasPrice;
    var handleApprove = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", proxyAddress && callWithGasPrice(lpContract, "approve", [
                        proxyAddress,
                        _ethersproject_constants__WEBPACK_IMPORTED_MODULE_5__/* .MaxUint256 */ .Bz
                    ]));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        lpContract,
        proxyAddress,
        callWithGasPrice
    ]);
    return {
        onApprove: handleApprove
    };
};


/***/ }),

/***/ 7938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_calls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56946);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36963);
/* harmony import */ var state_user_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(921);






var useUnstakeFarms = function(pid) {
    var masterChefContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_3__/* .useMasterchef */ .y8)();
    var gasPrice = (0,state_user_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useGasPrice */ .Fh)();
    var handleUnstake = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(amount) {
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", (0,utils_calls__WEBPACK_IMPORTED_MODULE_2__/* .unstakeFarm */ .dU)(masterChefContract, pid, amount, gasPrice));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(amount) {
            return _ref.apply(this, arguments);
        };
    }(), [
        masterChefContract,
        pid,
        gasPrice
    ]);
    return {
        onUnstake: handleUnstake
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useUnstakeFarms);


/***/ }),

/***/ 71537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* reexport safe */ _Farms__WEBPACK_IMPORTED_MODULE_1__.G; },
/* harmony export */   "S": function() { return /* binding */ FarmsPageLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Farms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35633);


var FarmsPageLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Farms__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: children
    });
};



/***/ }),

/***/ 74551:
/***/ (function(module) {

module.exports = JSON.parse('[{"inputs":[{"internalType":"address","name":"_cake","type":"address"},{"internalType":"address","name":"_cakePool","type":"address"},{"internalType":"address","name":"_v2","type":"address"},{"internalType":"uint256","name":"_max","type":"uint256"},{"internalType":"uint256","name":"_cA","type":"uint256"},{"internalType":"uint256","name":"_cB","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"address","name":"proxy","type":"address"},{"indexed":false,"internalType":"uint256","name":"pid","type":"uint256"}],"name":"ActiveFarmPool","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"address","name":"proxy","type":"address"},{"indexed":false,"internalType":"uint256","name":"pid","type":"uint256"}],"name":"DeactiveFarmPool","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"address","name":"proxy","type":"address"},{"indexed":false,"internalType":"uint256","name":"pid","type":"uint256"}],"name":"Refresh","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"factory","type":"address"}],"name":"UpdateBoostFactory","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"pid","type":"uint256"},{"indexed":false,"internalType":"bool","name":"status","type":"bool"}],"name":"UpdateBoostFarms","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"address","name":"proxy","type":"address"}],"name":"UpdateBoostProxy","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"oldCA","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"newCA","type":"uint256"}],"name":"UpdateCA","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"oldCB","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"newCB","type":"uint256"}],"name":"UpdateCB","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"lockedAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"lockedDuration","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"totalLockedAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"maxLockDuration","type":"uint256"}],"name":"UpdateCakePool","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"factory","type":"uint256"}],"name":"UpdateMaxBoostPool","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"pid","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"oldMultiplier","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"newMultiplier","type":"uint256"}],"name":"UpdatePoolBoostMultiplier","type":"event"},{"inputs":[],"name":"BOOSTER_FACTORY","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"BOOST_PRECISION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"BOOST_RATIO_PRECISION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"BOOST_WEIGHT_PRECISION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"CAKE","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"CAKE_POOL","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"CA_PRECISION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MASTER_CHEF","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_BOOST_POOL","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_BOOST_PRECISION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_CA","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_CB","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MIN_CA","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MIN_CB","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"activate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"}],"name":"activedPools","outputs":[{"internalType":"uint256[]","name":"pools","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"avgLockDuration","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"cA","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"cB","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"deactive","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"getUserMultiplier","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"isBoostedPool","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_lockedAmount","type":"uint256"},{"internalType":"uint256","name":"_lockedDuration","type":"uint256"},{"internalType":"uint256","name":"_totalLockedAmount","type":"uint256"},{"internalType":"uint256","name":"_maxLockDuration","type":"uint256"}],"name":"onCakePoolUpdate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"proxyContract","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"refresh","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_factory","type":"address"}],"name":"setBoostFactory","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_pid","type":"uint256"},{"internalType":"bool","name":"_status","type":"bool"}],"name":"setBoosterFarms","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_cA","type":"uint256"}],"name":"setCA","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_cB","type":"uint256"}],"name":"setCB","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_max","type":"uint256"}],"name":"setMaxBoostPool","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"address","name":"_proxy","type":"address"}],"name":"setProxy","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"updatePoolBoostMultiplier","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"userInfo","outputs":[{"internalType":"uint256","name":"size","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"whiteList","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"}]');

/***/ })

}]);